<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastros de clientes" style="margin-right: 10px;" @click.prevent="mtdpadroesapp()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>         -->
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <!-- CP FILTRO -->
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Razão Social</option>
                                </select>
                            </div>
                            <!-- CP CONTEUDO PESQUISA -->
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <!-- CP REGISTRO -->
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <!-- BUTTO LISTAR -->
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <!-- TABELA HEADER -->
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstfiliais"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.codfil }}
                                    </template>
                                    <template slot="stformula" slot-scope="item">
                                        <span v-if="parseInt(item.row.formulapadrao) === 1" class="badge badge-pill badge-success" style="background-color: #0acf97; font-size: 12px;">Formula padrão</span>
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button v-show="mtdverificaecommerce()" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdecommerceconfig(item.row)">
                                                <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="14px" height="14px" version="1.1" fill="#fff" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                                    viewBox="0 0 308.16 315.35"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                                    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
                                                    <g id="Camada_x0020_1">
                                                    <metadata id="CorelCorpID_0Corel-Layer"/>
                                                    <path class="fil0" d="M148.09 82.41c2.61,0.4 4.55,2.75 6.36,4.04 3.37,2.39 4.46,0.3 7.57,-0.96l3.89 -1.53c1.71,-0.68 2.32,-0.45 3.06,-1.96 0.61,-1.25 1.12,-7.05 1.74,-8.68 0.89,-2.34 6.61,-1.34 9.07,-1.35 5.3,-0.03 5.41,-0.78 6.22,4.18 1.43,8.71 2.46,6.67 5.25,8.11 1.07,0.55 0,0.22 1.69,0.8 1.83,0.63 1.89,0.71 3.48,1.56 3.05,1.62 4.66,-0.45 6.81,-2.01 6.58,-4.79 5.94,-2.69 12.4,3.21l0.65 0.6c0.06,0.06 0.15,0.14 0.21,0.2 0.65,0.65 0.18,0.11 0.6,0.65 0.18,0.23 0.79,1.21 0.88,1.64 0.28,1.31 -0.51,2.41 -1.21,3.49 -3.46,5.33 -5.55,3.97 -2.7,10.38l2.18 5.76c0.04,0.07 1.19,1.26 1.21,1.28 1.34,0.95 2.34,0.5 4.18,0.84 4.29,0.81 6.9,0.79 6.9,3.1 0.02,15.27 0.74,12.15 -5,13.34 -1.41,0.29 -1.86,0.64 -3.33,0.9 -3.36,0.58 -3.15,0.49 -4.67,5.71 -0.62,2.13 -3.12,4.65 -2.07,7.17 1.33,3.17 7.38,6.44 4.26,10.47 -0.85,1.09 -7.33,7.77 -8.38,7.86 -2.66,0.25 -5.17,-4.99 -10.01,-5 -1.16,-0 -7.81,2.93 -8.96,3.55 -1.88,1.01 -1.28,0.02 -2.02,1.74 -0.94,2.2 -0.97,4.28 -1.17,6.79 -0.22,2.76 -1.62,3.48 -4.52,3.48 -6.92,0 -9.72,0.97 -11.12,-2.77 -1.91,-5.12 0.91,-7.54 -5.13,-9.05 -5.87,-1.47 -6.99,-4.47 -10.2,-2.67 -6.51,3.66 -5.45,7.55 -12.41,0.26 -1.2,-1.25 -2.49,-2.36 -3.54,-3.55 -2.96,-3.36 1.56,-4.88 3.24,-9.04 0.74,-1.83 -0.02,-3.49 -0.88,-5.01 -3.24,-5.74 -1.65,-7.41 -5.42,-8.73 -7.02,-2.47 -9.61,3.75 -8.26,-15.77 1.05,-0.46 4.85,-1.61 6.2,-1.71 5.47,-0.38 3.34,-1.56 6.92,-8.94 0.87,-1.8 2.23,-3.08 0.8,-5.5 -2.63,-4.45 -6.42,-6.11 -2.96,-9.58 1.88,-1.88 6.09,-6.46 8.14,-7.28zm-59.16 141.74c-0.41,-1.11 4.11,-8.93 5.39,-11.25l3.29 -5.86c3.01,-5.75 1.48,-4.28 16.71,-4.28l142.99 0c9.42,0 16.76,1.65 22.13,-7.35 0.99,-1.66 2.97,-12.2 3.33,-14.6 0.27,-1.83 1.02,-2.45 1.18,-4.63 0.25,-3.55 0.2,-2.07 1.05,-4.79l4.01 -19.78c0.24,-2.33 0.03,-3.02 0.84,-5l4.29 -19.44c0.59,-2.1 -0.11,-3.39 0.76,-5.5 0.76,-1.82 1.72,-7.18 2.07,-9.62l2.2 -9.87c0.49,-1.52 0.39,-3.41 0.72,-5.12l3.35 -14.58c0.4,-1.88 0.11,-3.39 0.79,-5.05 1.13,-2.78 0.46,-2.44 0.94,-5.34l2.3 -9.75c0.65,-5.27 3.12,-10.64 -4.89,-17.09 -4.42,-3.56 -15.09,-2.45 -21.31,-2.45 -63.51,0 -127.02,0 -190.52,0 -3.89,0 -7.79,-0.04 -11.68,0.01 -5.87,0.06 -3.59,0.08 -4.93,-3.82 -1.89,-5.52 -3.01,-10.77 -4.69,-16.17 -3.79,-12.18 -17.49,-22.35 -31.23,-22.71 -6.94,-0.18 -16.53,-0.13 -23.35,0.5 -8.5,0.79 -11.85,3.11 -14.22,10.08 -0.99,2.93 -0.28,6.54 1.02,9.07 4.91,9.61 17.25,6.79 28.21,6.8 8.71,0 13.58,-1.03 15.6,8.16 0.77,3.49 1.75,5.64 2.41,9.27 0.41,2.26 0.74,0.39 1.35,4.51l3.58 14.36c0.38,1.79 0.19,3.58 0.73,5.07l4.32 19.41c0.67,1.86 0.13,3.46 0.77,5.49 1.16,3.69 3.82,18.49 4.23,19.53 0.95,2.41 0.5,2.49 0.8,5.06 0.23,1.94 0.99,2.26 1.23,5.02 0.27,3.11 1.44,6.95 2.19,9.87 0.54,2.12 -0.04,3.11 0.78,5.08l4.23 19.54c0.49,1.57 0.33,3.33 0.74,5.06 0.45,1.91 1.07,2.16 1.21,4.65l2.98 14.95c0.93,2.26 0.83,2.19 0.81,5.08 -0.01,1.25 0.07,1.7 -0.33,2.62l-14.65 27.02c-0.74,1.14 -0.49,0.6 -1.08,1.83 -0.46,0.96 -1.44,3.3 -1.79,4.5 -0.99,3.38 -0.86,9.2 0.55,12.96l1.87 3.99c1.28,2 2.19,3.38 4.03,5.13 2.48,2.35 8.32,5.66 12.18,5.73 8,0.15 16.18,-0.02 24.2,-0.02l154.25 0c7.02,0 8.39,0.64 13.1,-4.84 1.48,-1.73 1.68,-1.55 2.39,-3.84 1.04,-3.35 0.84,-6.68 -0.72,-9.83 -3.47,-7.02 -9.33,-7.45 -16.44,-7.44 -25.15,0.05 -164.55,0.45 -166.3,-0.31zm32.29 38.93c-15.91,2.44 -26.77,19.43 -21.01,34.38 2.96,7.68 8.47,13.66 16.5,16.41 7.47,2.56 13.67,1.73 20.46,-1.82 0.09,-0.04 0.19,-0.1 0.28,-0.14l2.42 -1.34c1.76,-1.19 4.35,-3.23 5.38,-4.63 6.51,-8.87 5.72,-10.95 5.76,-20.51 0.03,-7.61 -7.17,-16.51 -14.88,-20.14l-2.96 -1.21c-3.64,-1.04 -7.7,-1.65 -11.96,-0.99zm91.21 0.16c-6.43,1.05 -12.58,4.86 -16.48,10.02 -4.43,5.85 -6.12,13.85 -4.85,21.29 0.05,0.3 1.34,4.1 1.57,4.69l3.82 6.18c4.56,6.1 15.66,11.5 25.34,9.16 3.77,-0.91 6.54,-1.8 9.31,-3.62 4.18,-2.74 7.09,-6.04 9.43,-10.16 2.16,-3.78 3.56,-11.43 2.36,-16.39 -1.89,-7.79 -5.07,-12.33 -10.06,-16.21 -5.85,-4.54 -13.06,-6.16 -20.45,-4.95zm-13.79 -136.64c2.75,-6.63 -1.99,-16.92 -6.97,-20.64 -2.25,-1.68 -5.35,-3.63 -8.27,-4.23 -1.7,-0.35 -8.37,-0.31 -10,0.16 -19.09,5.56 -19.71,30.16 -4.25,37.84 4.53,2.26 1.78,0.78 5.6,1.91 4.29,1.27 4.48,0.64 8.54,-0.25 2.7,-0.59 4.04,-0.81 7.11,-2.92 5.05,-3.46 6.26,-7.1 8.24,-11.87z"/>
                                                    </g>
                                                </svg>
                                            </button>
                                            <button v-show="mtdverificarillpay()" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdrillpayconfig(item.row)">
                                                <img src="/icone-rpay-white.svg" style="width: 25px; height: 25px;" alt="icone rillpay">
                                            </button>
                                            <button v-show="mtdverificaclubrill()" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdcluberillsoftconfig(item.row)">
                                                <i class="fa fa-mobile"></i>
                                            </button>
                                        </div>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <!-- BADGE REGISTRO -->
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstfiliais.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <!-- PAGINATION -->
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <!-- BUTTO NOVO -->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10" style="margin-bottom: 15px;">
                                <div class="row">
                                    <!-- CP CÓDIGO -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edid">Código:</label>
                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vcodfil"
                                            maxlength="20" disabled/>
                                    </div>
                                    <!-- CP RAZÃO SOCIAL -->
                                    <div class="col-sm-12 col-md-10 col-lg-10">
                                        <label for="eddescricao">*Razão Social:</label>
                                        <input type="text" v-model="vdescfil" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="eddescricao" maxlength="50">
                                    </div>
                                    <!-- CP FANTASIA -->
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edfantasia">*Fantasia:</label>
                                        <input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edfantasia" data-bv-group=".group" maxlength="50">
                                    </div>
                                    <!-- CP CNPJ -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edcnpj">*CNPJ:</label>
                                        <input type="text" v-mask="'##.###.###/####-##'"
                                            class="form-control form-control-sm" id="edcnpj" v-model="vcnpj"
                                            v-bind:disabled="ativadesativa" data-bv-group=".group"
                                            maxlength="20">
                                    </div>
                                    <!-- CP INSCRIÇÃO ESTADUAL -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edie">Insc. Estadual:</label>
                                        <input type="text" class="form-control form-control-sm" id="edie" v-model="vie"
                                            data-bv-group=".group" maxlength="20" v-bind:disabled="ativadesativa">
                                    </div>
                                    <!-- CP INSCRIÇÃO ESTADUAL ST -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="ediest">Insc. Estadual ST:</label>
                                        <input type="text" class="form-control form-control-sm" id="ediest" v-model="viest"
                                            data-bv-group=".group" maxlength="20" v-bind:disabled="ativadesativa">
                                    </div>                       
                                    <!-- CP INSCRIÇÃO MUNICIPAL -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edim">Inscrição Municipal:</label>
                                        <input type="text" v-model="vim" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edim" maxlength="15">
                                    </div>                
                                    <!-- CP FONE (1)-->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edfone1">*Fone(1):</label>
                                        <input type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control form-control-sm" id="edfone1"
                                            v-model="vfone1" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                            maxlength="20">
                                    </div>
                                    <!-- CP FONE (2) -->
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edfone2">Fone(2):</label>
                                        <input type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control form-control-sm" id="edfone2"
                                            v-model="vfone2" v-bind:disabled="ativadesativa" data-bv-group=".group"
                                            maxlength="20">
                                    </div>
                                    <!-- CP EMAIL -->
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edemail">E-mail:</label>
                                        <input type="email" class="form-control form-control-sm" id="edemail" v-model="vemail"
                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100">
                                    </div>
                                    <!-- CP SITE -->
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edsite">Site:</label>
                                        <input type="text" class="form-control form-control-sm" id="edsite" v-model="vsite"
                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100">
                                    </div>
                                </div>
                            </div>	
                            <div class="col-md-2">
                                <div class="row text-center" style="padding: 0px 15px 0px 15px; margin-bottom: 15px;">
                                    <div class="col-md-12 border rounded" style="padding: 0px;">
                                        <input
                                            type="file" 
                                            id="ipselecionarimgfilial"
                                            accept="image/png, image/jpeg" 
                                            @change="mtdselecionarimagemfilial" 
                                            style="display: none;"
                                            ref="if_imgfilial">
                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgfilial" @click.prevent="mtdexcluirimgfilial()"><i class="fa fa-trash"></i></button>
                                        <img v-if="parseInt(opcrud) < 3" @click="$refs.if_imgfilial.click()" class="img-fluid img-filial" title="Clique aqui para selecionar uma imagen" v-bind:src="pathimagemvisualizar"> 
                                        <img v-else class="img-fluid img-filial" v-bind:src="pathimagemvisualizar">                                         
                                    </div>
                                </div>
                            </div>
                        </div>
						<div class="row">
							<div class="col-md-12">
                                <!-- TAB LIST -->
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvendereco">Endereço</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfaturamento">Faturamento</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfinanceiro">Financeiro</a>
                                    </li>
                                    <li v-show="mtdversistemafinanceiro()" class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvformula">Fórmula custo(produtos)</a>
                                    </li>
                                    <li v-show="mtdversistemafinanceiro()" class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvplanos">*Planos de pagamento</a>
                                    </li>  
                                    <li v-show="mtdversistemafinanceiro()" class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvmetadecompras">Meta de compras</a>
                                    </li>               
                                    
                                    <!--Luiz Trindade - Nova aba para cadastro de informações referentes a apis--> 
                                    <li  class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvapisinfo">API's</a>
                                    </li>                                 																		
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimpressoes">Impressões</a>
                                    </li>  
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcasback">Cashback</a>
                                    </li>                                 																		
                                </ul>
                                <!-- TAB CONTENTS -->
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvendereco" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <!-- CP CEP -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edcep">*CEP:</label>
												<input type="text" v-mask="'#####-###'" class="form-control form-control-sm"
													id="edcep" v-model="vcep" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="10">
											</div>
                                            <!-- CP LOGRADOURO -->
											<div class="col-sm-12 col-md-4 col-lg-4">
												<label for="edlogradouro">*Logradouro:</label>
												<input type="text" class="form-control form-control-sm" id="edlogradouro"
													v-model="vlogradouro" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="100">
											</div>
                                            <!-- CP NÚMERO -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="ednumeroendereco">*Número:</label>
												<input type="text" class="form-control form-control-sm" id="ednumeroendereco"
													v-model="vnumeroendereco" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="20">
											</div>
                                            <!-- CP REFERÊNCIA -->
											<div class="col-sm-12 col-md-4 col-lg-4">
												<label for="edreferencia">Referência:</label>
												<input type="text" class="form-control form-control-sm" id="edreferencia"
													v-model="vreferencia" v-bind:disabled="ativadesativa"
													data-bv-group=".group" maxlength="100">
											</div>
                                            <!-- CP BAIRRO -->
											<div class="col-sm-12 col-md-6 col-lg-6">
												<span class="lblselect2">*Bairro:</span>
												<select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione uma opção" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>
                                            <!-- CP MUNICÍPIO -->
											<div class="col-sm-12 col-md-4 col-lg-4">
												<span class="lblselect2">*Município:</span>
												<select id="cbmunicipio" v-model="vidmunicipio"
														v-bind:disabled="ativadesativa"
														data-placeholder="Selecione uma opção" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>
                                            <!-- CP UF -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<span class="lblselect2">*UF:</span>
												<select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione a uf" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>											
                                        </div>
                                    </div>
									<div id="dvfaturamento" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">VALORES PADRÃO (PEDIDOS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <!-- CP ESTOQUE PADRÃO -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Estoque padrão:</span>
                                                                <select id="cbestoque" data-placeholder="Selecione um estoque" v-model="videstoque" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <!-- CP VENDEDOR -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Vendedor:</span>
                                                                <select id="cbvendedor" data-placeholder="Selecione um plano" v-model="vidvendedor" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div> 
                                                            <!-- CP VENDEDOR CLIENTE -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbdefvendedorcliente">Vendedor do cliente:</label>
                                                                <select class="form-control form-control-sm" id="cbdefvendedorcliente" v-model="vdefvendedorcliente"
                                                                        title="Esta opção define se o vendedor carrega automaticamente do cadastro do cliente."
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>    
                                                            <!-- CP CLIENTE                                                                                                                    -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Cliente padrão:</span>
                                                                <select id="cbcliente" data-placeholder="Selecione um cliente" v-model="vidcliente" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <!-- CP  -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbentregaauto">Entrega auto:</label>
                                                                <select class="form-control form-control-sm" id="cbentregaauto" v-model="ventregaauto"
                                                                        title="Esta opção define se o pedido terá a opção 'entregar' marcada automaticamente."
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>  
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbreservaauto">Reservar auto:</label>
                                                                <select class="form-control form-control-sm" id="cbreservaauto" v-model="vreservaauto"
                                                                        title="Esta opção define se o pedido terá a opção 'reservar' marcada automaticamente."
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>  
                                                            <!-- CP PLANO PADRÃO -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">*Plano padrão:</span>
                                                                <select id="cbplano" data-placeholder="Selecione um plano" v-model="vidplano" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <!-- CP ATIVA BALANÇA -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarbalanca">Ativar balança:</label>
                                                                <select class="form-control form-control-sm" id="cbativarbalanca" v-model="vativarbalanca"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div> 
                                                         
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarcashback">Atz. clientes no PDV</label>
                                                                <select class="form-control form-control-sm" id="cbativarcashback" v-model="vatzclientepdv"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP QUANTIDADE DE MESAS/COMANDAS -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edqtdcomandas">Qtd mesas/comandas:</label>
                                                                <input type="number" v-model="vqtdcomandas" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edqtdcomandas" maxlength="11" min="0" title="Quantas vezes o cliente pode resgatar seu cashback ao mês">
                                                            </div>
                                                            <!-- cp taxa de serviço -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edtxservico">Tx. serviço:</label>
                                                                <div class="input-group" style="z-index: 1;">
                                                                    <money type="text" class="form-control form-control-sm" id="edtxservico" v-model="vtxservico"
                                                                        v-bind="money" v-bind:disabled="ativadesativa"
                                                                        data-bv-group=".group" style="text-align:right;" title="Percentual/valor da taxa de serviço para os modulos de restaurante"></money>
                                                                    <div class="input-group-append">
                                                                        <select class="form-control form-control-sm tptaxassel" id="cbtptxservico" v-model="vtptaxaservico"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="0">$</option>
                                                                            <option value="1">%</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>    
                                                            <!-- cp taxa de entrega -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edtxentrega">Tx. entrega:</label>
                                                                <div class="input-group" style="z-index: 1;">
                                                                    <money type="text" class="form-control form-control-sm" id="edtxentrega" v-model="vtxentrega"
                                                                        v-bind="money" v-bind:disabled="ativadesativa"
                                                                        data-bv-group=".group" style="text-align:right;" title="Percentual/valor da taxa de entrega para os modulos de restaurante"></money>
                                                                    <div class="input-group-append">
                                                                        <select class="form-control form-control-sm tptaxassel" id="cbtptxentrega" v-model="vtptaxaentrega"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="0">$</option>
                                                                            <option value="1">%</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- CP GRUPO DE BOTOES -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <span class="lblselect2">Grupo de botões padrão:</span>
                                                                <select id="cbgpbotoes" data-placeholder="Selecione um grupo" v-model="vgpbotoes" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>                                      
                                                        </div>
                                                    </div>
                                                </div>                                            
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">VALORES PADRÃO (NOTAS FISCAIS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="row">
                                                                    <!-- CP REGIME TRIBUTÁRIO -->
                                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                                        <label for="cbcrt">Regime tributário:</label>
                                                                        <select name="cbmod" class="form-control form-control-sm" id="cbcrt" v-model="vcrt">
                                                                            <option value="1">Simples Nacional</option>
                                                                            <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                                                            <option value="3">Regime Normal</option>
                                                                        </select>
                                                                    </div>
                                                                    <!-- CP NATUREZA DE OPERAÇÃO                                                             -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">*Natureza de operação:</span>
                                                                        <select id="cbnatop" data-placeholder="Selecione um registro" v-model="vidnatop" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                        </select>
                                                                    </div> 
                                                                    <!-- CP SÉRIE NF-E -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Série NF-e:</label>
                                                                        <input type="number" v-model="vserie55" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="3">
                                                                    </div>
                                                                    <!-- CP NR.INICIAL DA NF-e -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Nr. inicial da NF-e:</label>
                                                                        <input type="number" v-model="vnnf55" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="11">
                                                                    </div> 
                                                                    <!-- CP NR.INICIAL DA NF-e -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Série NFC-e:</label>
                                                                        <input type="number" v-model="vserie65" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="3">
                                                                    </div>
                                                                    <!-- CP NR.INICIAL DA NFC-E -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edserie">*Nr. inicial da NFC-e:</label>
                                                                        <input type="number" v-model="vnnf65" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edserie" maxlength="11">
                                                                    </div>
                                                                    <!-- CP CNAE -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edcnae">CNAE:</label>
                                                                        <input type="text" v-model="vcnae" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcnae" maxlength="7">
                                                                    </div> 
                                                                    <!-- CP SENHA CERTIFICADO -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edsenhacertificado">Senha certificado:</label>
                                                                        <input type="password" v-model="vsenhacertificado" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edsenhacertificado" maxlength="20">
                                                                    </div>
                                                                    <!-- CP CSC -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edcsc">CSC:</label>
                                                                        <input type="text" v-model="vcsc" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcsc" maxlength="50">
                                                                    </div>
                                                                    <!-- CP ID.CSC -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="edcscid">Id. CSC:</label>
                                                                        <input type="text" v-model="vcscid" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edcscid" maxlength="50">
                                                                    </div>
                                                                    <!-- CP TIPO DE AMBIENTE -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbtpamb">Tipo de ambiente:</label>
                                                                        <select class="form-control form-control-sm" id="cbtpamb" v-model="vtpamb"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="1">Produção</option>
                                                                            <option value="2">Homologação</option>
                                                                        </select>
                                                                    </div>
                                                                    <!-- CP CLASSE PADRÃO -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">*Classe padrão:</span>
                                                                        <select id="cbclasse" data-placeholder="Selecione uma classe" v-model="vidclasse" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;" title="Valor que será atribuído ao protudo caso não esteja atribuído para a filial no cadastro">
                                                                        </select>
                                                                    </div> 
                                                                    <!-- CP INF.COMPLEMENTAR PADRÃO -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <span class="lblselect2">Inf. complementar padrão:</span>
                                                                        <select id="cbinfcomplementar" data-placeholder="Selecione a informação complementar" v-model="vidinformacaocomplementar" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <!-- INFORMAR DADOS RESPONSÁVEL SOFTWARE -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                                                        <label for="cbgerartagsoftware">Gerar informações software:</label>
                                                                        <select class="form-control form-control-sm" id="cbgerartagsoftware" v-model="vgerartagsoftware"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="0">Não</option>
                                                                            <option value="1">Sim</option>
                                                                        </select>
                                                                    </div>
                                                                    <!-- CP CLASSE PARA GERAÇÃO DE TAXA DE SERVIÇO -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                                                        <span class="lblselect2">Classe tx. serviço:</span>
                                                                        <select id="cbclasseservico" data-placeholder="Selecione uma classe" v-model="vidclasseservico" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;" title="Valor que será atribuido a taxa de serviço de restaurantes para a NFC-e">
                                                                        </select>
                                                                    </div>     
                                                                    <!-- CÁLCULO AUTOMÁTICO ICMS -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                                                        <label for="cbcalculoicms">Anula cálc. auto. ICMS:</label>
                                                                        <select class="form-control form-control-sm" id="cbcalculoicms" v-model="vcalculoicms"
                                                                                v-bind:disabled="ativadesativa">
                                                                            <option value="0">Não</option>
                                                                            <option value="1">Sim</option>
                                                                        </select>
                                                                    </div>                                                                                                                                                                                
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edemailautomaticoxml">E-mail automático xmls:</label>
                                                                        <input type="email" class="form-control form-control-sm" id="edemailautomaticoxml" v-model="vemailautomaticoxml"
                                                                            data-bv-group=".group" v-bind:disabled="ativadesativa" maxlength="100" title="Informe o e-mail ao qual serão enviados automaticamente os xmls das NFs emitidas.">
                                                                    </div>                                                                                                                                                                                                                                             
                                                                    <div v-if="lstcertificados.length === 0" class="col-md-12 text-center" style="margin-top: 15px;">
                                                                        <input
                                                                            type="file" 
                                                                            id="ipselecionarcertificado"
                                                                            accept=".pfx" 
                                                                            @change="mtdselecionarcertificado" 
                                                                            style="display: none;"
                                                                            ref="if_certfilial">                                                                
                                                                        <button type="button" @click="$refs.if_certfilial.click()" class="btn btn-success btn-verde"><i class="fa fa-certificate"></i> Selecionar arquivo de certificado A1</button>
                                                                    </div>
                                                                    <div v-if="lstcertificados.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                                        <ul class="list-group">
                                                                            <li v-for="(arquivo, index) in lstcertificados" v-bind:key="index" class="list-group-item list-group-item-action">
                                                                                <div class="row">
                                                                                    <div class="col-md-1 text-center">
                                                                                        <i class="fa fa-lock" style="font-size: 26px; color: #4250f2;"></i>
                                                                                    </div>
                                                                                    <div class="col-md-11">                                                                                
                                                                                        <div class="col-md-12">
                                                                                            <a v-bind:href="adrsrvcert +'/'+ arquivo.patharquivo" class="btn btn-info btn-baixar-certificado" role="button" title="Baixar certificado" target="_blank"><i class="fa fa-download"></i></a>
                                                                                            <h5 style="font-size: 18px; color: #6c757d; font-weight: bold; margin-bottom: -1px;">{{ arquivo.nome }} - {{ formatadoc(arquivo.cnpjcpf) }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.emissor }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.email }}</h5>
                                                                                            <h5 style="font-size: 14px; color: #6c757d; margin-bottom: -1px;">{{ arquivo.validade }}</h5>
                                                                                        </div>
                                                                                        <div class="col-md-12" style="margin-top: 10px;">
                                                                                            <span id="op_exc_cert" @click.prevent="mtdexcluircertificado(arquivo.patharquivo)"><i class="fa fa-lock"></i> <strong>Remover certificado</strong></span><br>
                                                                                            <span style="font-size: 10px; color: #6c757d;"><strong>* Caso o certificado seja removido, não manteremos backup do mesmo.</strong></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>                                                                                                                                                
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-2">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <!-- CP CPF/CNPJ -->
                                                                        <label for="edidprodutoprod">CPF/CNPJ autorizado:</label>
                                                                        <div class="input-group" style="z-index: 1;">
                                                                            <input type="text" title="Adicionar terceiros que podem consultar as XMLs das NFE emitidas." class="form-control form-control-sm" id="edidprodutoprod" v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="vcpfcnpjaut" maxlength="20">
                                                                            <div class="input-group-append">
                                                                                <a href="#"  class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdaddcpfcnpjaut()" ><i  class="fa fa-plus" style="padding-top: 3px;"></i></a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12" style="margin-top: 20px;">
                                                                        <ul class="list-group">
                                                                            <li v-for="(item, index) in lstcpfcnpjaut" :key="index" class="optask-list list-group-item d-flex justify-content-between align-items-center list-group-item-action">
                                                                                <span><i @click.prevent="mtdexcluircpfcnpjaut(item)" class="fa fa-trash" style="color: #e23333; cursor: pointer"></i></span>
                                                                                <span style="font-size: 12px; font-weight: bold;">{{  formatadoc(item.cpfcnpj) }}</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>  
                                                            </div>      
                                                        </div> 
                                                    </div>
                                                </div>                                            
                                            </div>                                            
                                        </div>										
									</div>                                     
                                    <div id="dvfinanceiro" class="container-fluid tab-pane">
                                        <div class="row">

                                             <!-- CP DIAS CARENCIA-->
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiascarencia">Dias de carência:</label>
                                                <input type="number" v-model="vdiascarencia" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="eddiascarencia">
                                            </div>

                                            <!-- CP TIPO DE JUROS -->
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpjuros">Tipo Juros:</label>
												<select name="cbtpjuros" class="form-control form-control-sm" id="cbtpjuros" v-model="vtpjuros" v-bind:disabled="ativadesativa">
													<option value=0>Simples</option>
													<option value=1>Composto</option>
												</select>
											</div>
                                            <!-- CP TP.CÁLCULO DE JUROS	-->
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpcaljuros">Tp. Cálculo juros:</label>
												<select name="cbtpcalcjuros" class="form-control form-control-sm" id="cbtpcalcjuros" v-model="vtpcalcjuros" v-bind:disabled="ativadesativa">
													<option value=0>Percentual</option>
													<option value=1>Valor</option>
												</select>
											</div>
                                            <!-- CP FATOR JUROS -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edfatjuros">Fator Juros:</label>
												<money type="text" class="form-control form-control-sm" id="edfatjuros" v-model="vfatjuros"
														v-bind="moneyprecision" v-bind:disabled="ativadesativa"
														data-bv-group=".group" style="text-align:right;"></money>
											</div>				
                                            <!-- CP TP.CÁLCULO MULTA																		 -->
											<div class="col-12 col-sm-2 col-md-2 col-lg-2">
												<label for="cbtpcalmulta">Tp. Cálculo Multa:</label>
												<select name="cbtpcalmulta" class="form-control form-control-sm" id="cbtpcalmulta" v-model="vtpcalcmulta" v-bind:disabled="ativadesativa">
													<option value=0>Percentual</option>
													<option value=1>Valor</option>
												</select>
											</div>
                                            <!-- CP FATOR MULTA -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edfatmulta">Fator multa:</label>
												<money type="text" class="form-control form-control-sm" id="edfatmulta" v-model="vfatmulta"
														v-bind="moneyprecision" v-bind:disabled="ativadesativa"
														data-bv-group=".group" style="text-align:right;"></money>
											</div>
                                            <!-- CP COBRADOR -->
											<div class="col-sm-12 col-md-2 col-lg-2">
												<span class="lblselect2">*Cobrador:</span>
												<select id="cbcobrador" v-model="vidcobrador" v-bind:disabled="ativadesativa"
														data-placeholder="Selecione um cobrador" data-allow-clear="true"
														style="width:100%;">
												</select>
											</div>																																																											
                                        </div>
                                    </div>                                   																			
									<div id="dvformula" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-9" >
                                                <label style="padding-bottom: 20px;" for="txtformula">Formula padrão: {{temformulapadrao ? 'Sim' : 'Não'}}</label>
                                            </div>
                                            <div class="col-sm-3" >
                                                <button type="button" id="btincplano" :class="!temformulapadrao ? 'btn btn-info btn-sm' : 'btn btn-danger btn-sm'" @click.prevent="mtddefinirformulapadrao()" style="width:100%;"><i class="fa fa-bolt"></i> {{temformulapadrao ? 'Remover Formula padrão' : 'Definir como padrão' }}</button>
                                            </div>
                                           
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="8" id="txtformula" v-model="vformulacustoproduto" v-bind:disabled="ativadesativa"></textarea>
                                            </div>  
                                            <div class="col-sm-12">
                                                <span style="font-size: 14px; color: #e23333">
                                                    PC  = Preço de compra / IPI = Percentual de IPI / ICM = Percentual de ICMS / STB = Valor da Subst. Tributária / FT  = Percentual de Frete / OT  = Percentual de Outras despesas / PIS = Percentual de PIS / COF = Percentual de COFINS / PV  = Preço de venda
                                                </span>
                                            </div>                                        
                                        </div>										
									</div>
									<div id="dvplanos" class="container-fluid tab-pane">
                                        <div class="row">
                                            <!-- CP PLANO DE PAGAMENTO -->
                                            <div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-6">
                                                <label for="cbplanopagamento">Plano de pagamento:</label>
                                                <select id="cbplanopagamento" data-placeholder="Selecione um plano" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidplanolst" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>
                                            <!-- BUTTON INCLUIR -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-2">
                                                <button type="button" id="btincplano" class="btn btn-info btn-sm" @click.prevent="mtdincplano()" style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i> Incluir</button>
                                            </div>
                                            <!-- BUTTON SELECIONAR (USAR v-on:change="") -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-2">
                                                <button type="button" id="btselecplano" class="btn btn-info btn-sm" style="width:100%; margin-top: 21px;" @click.prevent="mtdrotinaplano()"><i class="fa fa-search-plus"></i> Selecionar</button>
                                            </div>
                                            <!-- BUTTON EXCLUIR SELECIONADOS -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-2">
                                                <button type="button" id="btnexcluirselecionados" class="btn btn-info btn-sm" style="width:100%; margin-top: 21px;" @click.prevent="mtdexcluirselecao()"><i class="fa fa-trash"></i> Excluir</button>
                                            </div>
                                            <!-- TB PLANO DE PAGAMENTOS -->
                                            <div v-if="lstplanos.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistaplanos" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                            <tr>
                                                                <th scope="col" style="width:35px;padding-left:9px">
                                                                    <i @click.prevent="mtdmarcartodas()" 
                                                                       class="fa fa-plus-square" 
                                                                       aria-hidden="true"
                                                                       style="cursor: pointer;font-size: 18px;position: relative;top: 3px;">
                                                                    </i>
                                                                </th>
                                                                <th>Plano de pagamento:</th>
                                                                <th v-if="parseInt(opcrud) < 3" width="15px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="lstplanosfilial">
                                                            <tr v-for="(plano, index) in lstplanos" v-bind:key="index">

                                                                <td @click.prevent="mtdhabilita(index)" style="font-size: 18px;padding-top: 6.5px;padding-left: 9px">
                                                                    <i v-if="plano.marcado === 1"  class="fa fa-check-square-o" aria-hidden="true" style="cursor: pointer;"></i> 
                                                                    <i v-else class="fa fa-square-o"  aria-hidden="true" style="cursor: pointer;"></i> 
                                                                </td>

                                                                <td>{{mtdformatarzeros(plano.idplano, 2)}} - {{ plano.descplano }}</td>

                                                                <td v-if="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletaplano(index)"><i class="fa fa-trash"></i></a>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                       
                                        </div>										
									</div>

                                    <div id="dvmetadecompras" class="container-fluid tab-pane">
                                        <div class="row">
                                            <!-- CP MÊS -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edmes">Mês:</label>
                                                <select id="edmes" class="form-control form-control-sm" v-model="vmes" data-bv-group=".group">
                                                    <option value="1">Janeiro</option>
                                                    <option value="2">Fevereiro</option>
                                                    <option value="3">Março</option>
                                                    <option value="4">Abril</option>
                                                    <option value="5">Maio</option>
                                                    <option value="6">Junho</option>
                                                    <option value="7">Julho</option>
                                                    <option value="8">Agosto</option>
                                                    <option value="9">Setembro</option>
                                                    <option value="10">Outubro</option>
                                                    <option value="11">Novembro</option>
                                                    <option value="12">Dezembro</option>
                                                </select>
                                            </div>
                                            <!-- CP ANO -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edano">Ano:</label>
                                                <select name="edano" class="form-control form-control-sm" id="edano" v-model="vano" >
                                                    <option v-for="(ano, index) in anoslista" :key="index" :value="ano">{{ ano }}</option>
                                                </select>
                                            </div>
                                            <!-- CP VALOR META -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvalormeta">Valor:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvalormeta" v-model="vvalormeta" v-bind="money" v-bind:disabled="ativadesativa" data-bv-group=".group" style="text-align:right; color: #536877; font-weight: bold"></money>
                                            </div>
                                            <!-- BUTTON ADD META -->
                                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-2 col-lg-3">
                                                <button type="button" id="btincmeta" class="btn btn-info btn-sm" @click.prevent="mtdincmeta()" style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>Incluir</button>
                                            </div> 
                                            <!-- TB PLANO DE PAGAMENTOS -->
                                            <div v-if="lstmetasdecompra.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistametas" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                        <tr>
                                                            <th>Mês/Ano:</th>
                                                            <th>Valor</th>
                                                            <th v-if="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstmetasfilial">
                                                            <tr v-for="(meta, index) in lstmetasdecompra" v-bind:key="index">
                                                                <td style="color: #5c8f94; font-weight: bold;">
                                                                    <span v-if="parseInt(meta.mes) === 1"      >Janeiro / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 2" >Fevereiro / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 3" >Março / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 4" >Abril / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 5" >Maio / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 6" >Junho / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 7" >Julho / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 8" >Agosto / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 9" >Setembro / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 10" >Outubro / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 11">Novembro / {{ meta.ano }}</span>
                                                                    <span v-else-if="parseInt(meta.mes) === 12">Dezembro / {{ meta.ano }}</span>
                                                                </td>
                                                                <td style="color: #5c8f94; font-weight: bold; text-align: right;">{{ mtdformatavalordecimal(parseFloat( meta.valor), 2) }}</td>
                                                                <td v-if="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#" v-bind:disabled="ativadesativa" @click.prevent="mtddeletameta(index)"><i class="fa fa-trash"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                       
                                        </div>										
									</div>               
                                    <!--APIS-->
                                    <div id="dvapisinfo" class="container-fluid tab-pane">
                                        <div class="row mt-4 pt-2">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 500; font-size: 18px;"><i class="fa fa-cog" aria-hidden="true"></i> API´s disponíveis</h5>
                                                <hr>
                                            </div>
                                            <div v-show="mtdversistemafinanceiro()" class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarifood()" type="checkbox" class="custom-control-input" id="swApiIfoodinput" v-model="swApiIfood" name="swApiIfood">
                                                    <label class="custom-control-label" for="swApiIfoodinput">
                                                        Ifood
                                                        <!-- <span v-if="vifood" class="badge badge-primary ml-3" style="background-color: green;">Ativo</span>
                                                        <span v-else class="badge badge-danger ml-3">Inativo</span> -->
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosApiIfood">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <!--ClientId-->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edclientid">*Client ID:</label>
                                                                        <input type="text" v-model="vclientIdIfood" 
                                                                            class="form-control form-control-sm" id="edclientid" maxlength="200">
                                                                    </div>

                                                                    <!--ClientSecret-->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edclientsecret">*Client Secret:</label>
                                                                        <input type="text" v-model="vclientSecretIfood" 
                                                                            class="form-control form-control-sm" id="edclientsecret" maxlength="200">
                                                                    </div>

                                                                    <!--MerchantId-->
                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                        <label for="edclientsecret">*Merchant ID:</label>
                                                                        <input type="text" v-model="vmerchantIdIfood"
                                                                            class="form-control form-control-sm" id="edclientsecret" maxlength="200">
                                                                    </div>
                                                                    <!-- <div class="col-sm-12 col-md-2 col-lg-6">
                                                                        <button v-if="!vifood" @click.prevent="mtdconfirmaalteracaoifood('habilitar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Habilitar
                                                                        </button>
                                                                        <button v-if="vifood" @click.prevent="mtdconfirmaalteracaoifood('alterar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Aplicar alterações
                                                                        </button>
                                                                    </div> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarApiWhats()" type="checkbox" class="custom-control-input" id="swApiWhatsinput" v-model="swApiWhats" name="swApiWhats">
                                                    <label class="custom-control-label" for="swApiWhatsinput">
                                                        WhatsApp Business
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosApiWhats">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="row">
                                                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                                                <label for="edaccesstoken">Access Token:</label>
                                                                                <input type="text" v-model="vaccesstokenwaba"
                                                                                    class="form-control form-control-sm" id="edaccesstoken" disabled>
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                                <label for="edexpirantiontoken">Expiration Token:</label>
                                                                                <input type="text" v-model="vexpirationtokenwaba"
                                                                                    class="form-control form-control-sm" id="edexpirantiontoken" disabled>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                                                <label for="edwaba">WABA ID:</label>
                                                                                <input type="text" v-model="vidwaba"
                                                                                    class="form-control form-control-sm" id="edwaba" maxlength="200" disabled>
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                                                <label for="edphonenumber">Phone Number ID:</label>
                                                                                <input type="text" v-model="vidphonenumber"
                                                                                    class="form-control form-control-sm" id="edphonenumber" maxlength="200" disabled>
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                                <button type="button" class="btn btn-success btn-sm btn-definirtema" @click.prevent="iniciarWhatsAppSignup()">
                                                                                    <i class="fa fa-cloud-download" aria-hidden="true"></i> Importar WABA
                                                                                </button>
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                                <button type="button" class="btn btn-success btn-sm btn-definirtema" @click.prevent="cadastrarWebhookWaba()">
                                                                                    <i class="fa fa-podcast" aria-hidden="true"></i> Cadastrar Webhook
                                                                                </button>
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                                <button type="button" class="btn btn-success btn-sm btn-definirtema" @click.prevent="cadastrarTelefoneWaba()">
                                                                                    <i class="fa fa-phone" aria-hidden="true"></i> Cadastrar Telefone
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <button v-if="!vApiWhatsapp" @click.prevent="mtdconfirmaalteracaocartaocred('habilitar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Habilitar
                                                                        </button>
                                                                        <button v-if="vApiWhatsapp" @click.prevent="mtdconfirmaalteracaocartaocred('alterar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Aplicar alterações
                                                                        </button>
                                                                    </div> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarApiBeiraRio()" type="checkbox" class="custom-control-input" id="swApiBeiraRio" v-model="swApiBeiraRio" name="swApiBeiraRio">
                                                    <label class="custom-control-label" for="swApiBeiraRio">
                                                        Importador de produtos (Beira Rio)
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosApiBeiraRio">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="row">
                                                                            <div class="col-sm-12 col-md-8 col-lg-4">
                                                                                <label for="edclientid">Client id:</label>
                                                                                <input type="text" v-model="vClientIdBeiraRio"
                                                                                    class="form-control form-control-sm" id="edclientid" >
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-8 col-lg-4">
                                                                                <label for="edclientsecret">Client secret:</label>
                                                                                <input type="text" v-model="vClientSecretBeiraRio"
                                                                                    class="form-control form-control-sm" id="edclientsecret" >
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-8 col-lg-4">
                                                                                <label for="edusuariobeirario">Usuário:</label>
                                                                                <input type="text" v-model="vUsuarioBeiraRio"
                                                                                    class="form-control form-control-sm" id="edusuariobeirario" >
                                                                            </div>
                                                                            <div class="col-sm-12 col-md-8 col-lg-4">
                                                                                <label for="edsenhabeirario">Senha:</label>
                                                                                <input type="text" v-model="vSenhaBeiraRio"
                                                                                    class="form-control form-control-sm" id="edsenhabeirario" >
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarApiPlacas()" type="checkbox" class="custom-control-input" id="swApiPlacas" v-model="swApiPlacas" name="swApiPlacas">
                                                    <label class="custom-control-label" for="swApiPlacas">
                                                        Consulta Placas
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosApiPlacas">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="row">
                                                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                                                <label for="edtokenplacas">Access Token:</label>
                                                                                <input type="text" v-model="vTokenPlacas"
                                                                                    class="form-control form-control-sm" id="edtokenplacas" >
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvimpressoes" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">IMPRESSÃO (FATURAMENTO - PEDIDOS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <!-- CP IMPRIME LOGO CUPOM -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbimprimelogocupom">Imprimir logo no cupom:</label>
                                                                <select class="form-control form-control-sm" id="cbimprimelogocupom" v-model="vimprimelogocupom"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP IMPRIME CUPOM RESUMIDO -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbcupomresumido">L. Cupom:</label>
                                                                <select class="form-control form-control-sm" id="cbcupomresumido" v-model="vcupomresumido"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Padrão</option>
                                                                    <option value="1">Layout 1</option>
                                                                    <option value="2">Layout 2</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP ORDEM ITEMS -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbordemitens">Ordem itens:</label>
                                                                <select class="form-control form-control-sm" id="cbordemitens" v-model="vordemitens"
                                                                        title="Ordem dos itens na impressão do pedido"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Item</option>
                                                                    <option value="1">Descrição</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP CULTAR DESCONTO -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbocultardesconto">Ocultar desconto:</label>
                                                                <select class="form-control form-control-sm" id="cbocultardesconto" v-model="vocultardesconto"
                                                                        title="Essa opção quando selecionada 'Sim' oculta o desconto na impressão do pedido."
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>         
                                                            <!-- CP INFOIMP -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbinfoimp">Cabeçalho:</label>
                                                                <select class="form-control form-control-sm" id="cbinfoimp" v-model="vinfofilial"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarcashback">Saldo no cupom</label>
                                                                <select class="form-control form-control-sm" id="cbativarcashback" v-model="vsaldocupom"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP IMPPADRAO -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbimppadrao">Impressão padrão:</label>
                                                                <select class="form-control form-control-sm" id="cbimppadrao" v-model="vimppadrao"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Cupom</option>
                                                                    <option value="2">A4</option>
                                                                    <option value="3">Guia de balcão</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP OBS ETIQUETA DE TROCA -->
                                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                                <label for="edobstroca">Observação etiqueta de troca:</label>
                                                                <input type="text" v-model="vobsetitroca" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edobstroca" maxlength="200">
                                                            </div>  
                                                             <!-- CP RECIBO RODAPÉ -->
                                                             <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbreciborodape">Recibo no rodapé:</label>
                                                                <select class="form-control form-control-sm" id="cbreciborodape" v-model="vreciborodape"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div> 
                                                            <!-- CP DESCRICAÇÃO (RODAPÉ DOS PEDIDOS) -->
                                                            <div class="col-sm-12 col-md-7 col-lg-10">
                                                                <label for="eddescricao">*Mensagem rodapé dos pedidos:</label>
                                                                <input type="text" v-model="vmensagempedido" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="eddescricao" maxlength="200">
                                                            </div> 
                                                            <!-- CP OBS PEDIDOS ABERTOS -->
                                                            <div class="col-sm-12 col-md-5 col-lg-12">
                                                                <label for="edobsfat">Observações para pedidos abertos:</label>
                                                                <input type="text" v-model="vobsfatped" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edobsfat" maxlength="200">
                                                            </div>                                                   
                                                            <!-- CP OBS GUIA ENTREGA EXTERNA -->
                                                            <div class="col-sm-12 col-md-5 col-lg-12">
                                                                <label for="edobsentexterna">Observações para guia de entrega externa:</label>
                                                                <input type="text" v-model="vobsentexterna" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edobsentexterna" maxlength="200">
                                                            </div>  
                                                            <!-- CP OBS CREDIÁRIO -->
                                                            <div class="col-sm-12 col-md-5 col-lg-12">
                                                                <label for="edobscrediario">Observações do crediário:</label>
                                                                <input type="text" v-model="vobscrediario" v-bind:disabled="ativadesativa"
                                                                    class="form-control form-control-sm" id="edobsentexterna" maxlength="200">
                                                            </div>                                                               
                                                        </div>
                                                    </div>
                                                </div>                                            
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">IMPRESSÃO (FATURAMENTO - NOTAS FISCAIS)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="row">
                                                                    <!-- VISUALIZAR INFORMAÇÕES IMPOSTO ITEM DANFE -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-6">
                                                                        <label for="cbdescprodinfocomplemento">Informações produto - DANFE:</label>
                                                                        <select class="form-control form-control-sm" id="cbdescprodinfocomplemento" v-model="vdescprodinfocomplemento"
                                                                            v-bind:disabled="ativadesativa" title="Exibe informações dos impostos do item na DANFE">
                                                                            <option value="0">Não</option>
                                                                            <option value="1">Sim</option>
                                                                        </select>
                                                                    </div> 
                                                                    <!-- LAYOUT IMPRESSÃO CUPOM NFC-E -->
                                                                    <div class="col-sm-12 col-md-4 col-lg-6">
                                                                        <label for="cblayoutimp">Layout impressão - NFC-e:</label>
                                                                        <select class="form-control form-control-sm" id="cblayoutimp" v-model="vlayoutimp"
                                                                            v-bind:disabled="ativadesativa" title="Seleciona entre os dois modelos disponiveis de cupom fiscal">
                                                                            <option value="0">layout 1</option>
                                                                            <option value="1">layout 2</option>
                                                                        </select>
                                                                    </div>	
                                                                </div>
                                                            </div>     
                                                        </div> 
                                                    </div>
                                                </div>                                            
                                            </div>                                            
                                            <div class="col-md-12" style="margin-top: 15px;">                                                
                                                <div class="card">
                                                    <div class="card-header card-in">IMPRESSÃO (FINANCEIRO)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="row">
                                                                    <!-- CP OBS RECIBO -->
                                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                                        <label for="edobsrecibo">Observação recibo:</label>
                                                                        <input type="text" v-model="vobsrecibo" v-bind:disabled="ativadesativa"
                                                                            class="form-control form-control-sm" id="edobsrecibo" maxlength="200">
                                                                    </div>	
                                                                </div>
                                                            </div>     
                                                        </div> 
                                                    </div>
                                                </div>                                            
                                            </div>                                            
                                        </div>										
									</div>
                                    <div id="dvcasback" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">  
                                                <div class="card">
                                                    <div class="card-header card-in">VALORES PADRÃO (CASHBACK)</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                             <!-- CP ATIVAR CASHBACK                                                                                                                         -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarcashback">Ativar Cashback:</label>
                                                                <select class="form-control form-control-sm" id="cbativarcashback" v-model="vativacashback"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                            <!-- CP REDITO INDIVIDUAL -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbcreditoindividual">Cashback individual:</label>
                                                                <select class="form-control form-control-sm" id="cbcreditoindividual" v-model="vcreditoindividual"
                                                                        v-bind:disabled="ativadesativa || vativacashback===0">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div> 
                                                            <!-- CP FATOR CREDITO ULTILIZAR -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edfatorcreditoutilizar">Utilizar cashback(%):</label>
                                                                <money type="text" class="form-control form-control-sm" id="edfatorcreditoutilizar" v-model="vfatorcreditoutilizar"
                                                                        v-bind="money" v-bind:disabled="ativadesativa || parseInt(vativacashback)===0"
                                                                        data-bv-group=".group" style="text-align:right;" title="Percentual permitido para utilização do total da venda/recebimento"></money>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbloqueiacbatraso">Bloquear saldo atraso</label>
                                                                <select class="form-control form-control-sm" title="Dificulta o resgate de cashback para inadimplentes." id="cbloqueiacbatraso" v-model="vbloqueiacbatraso"
                                                                        v-bind:disabled="ativadesativa || parseInt(vativacashback)===0">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                             <!-- CP VALIDADE CASHBACK -->
                                                             <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edvalidadecashback">Validade Cashback(dias):</label>
                                                                <input type="number" v-model="vvalidadecashback" v-bind:disabled="ativadesativa || parseInt(vativacashback)===0"
                                                                    class="form-control form-control-sm" id="edvalidadecashback" maxlength="11" min="0" title="validade do cashback após sua origem.">
                                                            </div>
                                                            <!-- CP FATOR CREDITO ULTILIZAR -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edregsteminimocb">Resgate minimo($):</label>
                                                                <money type="text" class="form-control form-control-sm" id="edregsteminimocb" v-model="vresgateminimocb"
                                                                        v-bind="money" v-bind:disabled="ativadesativa || parseInt(vativacashback)===0"
                                                                        data-bv-group=".group" style="text-align:right;" title="Valor mínimo para venda ser elegível de resgate"></money>
                                                            </div>
                                                            <!-- CP ATIVAR CASHBACK LIQUIDEZ -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbativarcashbackliquidez">Cashback liquidez:</label>
                                                                <select class="form-control form-control-sm" title="Irá acumular cashback nas liquidações de titulos." id="cbativarcashbackliquidez" v-model="vativacashbackliquidez"
                                                                        v-bind:disabled="ativadesativa || parseInt(vativacashback)===0">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                           <!-- cp FATOR CASHBACK LIQUIDEZ--> 
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edfatorcreditoliquidez">Fator cb. liquidez(%):</label>
                                                                <money type="text" class="form-control form-control-sm" id="edfatorcreditoliquidez" v-model="vfatorliquidez"
                                                                        v-bind="money" v-bind:disabled="ativadesativa || parseInt(vativacashback)===0 && parseInt(vativacashbackliquidez)===0"
                                                                        data-bv-group=".group" style="text-align:right;" title="Percentual de acumulo de cashback após liquidação de um titulo"></money>
                                                            </div>
                                                            <!-- CP QUANTIDADE RESGATE CASHBACK -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edqtdresgatecashback">Resgates ao mês(CB):</label>
                                                                <input type="number" v-model="vqtdresgatescashback" v-bind:disabled="ativadesativa  || parseInt(vativacashback)===0"
                                                                    class="form-control form-control-sm" id="edqtdresgatecashback" maxlength="11" min="0" title="Quantas vezes o cliente pode resgatar seu cashback ao mês">
                                                            </div>

                                                            <!-- Bloquear para titulo--> 
                                                           <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbbaixatitcashback">Utilizar para baixa de titulo:</label>
                                                                <select class="form-control form-control-sm" id="cbbaixatitcashback" v-model="vbaixatitcashback"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>

                                                           <!-- cp troco virtual--> 
                                                           <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="cbtrocovirtual">Troco virtual:</label>
                                                                <select class="form-control form-control-sm" id="cbtrocovirtual" v-model="vtrocovirtual"
                                                                        v-bind:disabled="ativadesativa">
                                                                    <option value="0">Não</option>
                                                                    <option value="1">Sim</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
								</div>
							</div>                              
						</div>	
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal atribuir planos de pagamento -->
        <div class="modal fade" id="mdatribuirplano" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-user-plus" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir Planos de Pagamento</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <!-- Campo "plano de pagamentos" -->
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label class="lbselect2">Grupo de pagamentos:</label>
                                <select id="cbgruppagamento" data-placeholder="Selecione um grupo de pagamento" v-model="vidgrup" ref="selectatr" data-allow-clear="true" change="listarplanosatr" style="width:100%;"></select>
                            </div>       
                            <!-- Table plano de pagamentos -->
                            <div class="col-md-12" id="ex-dvclasseatribuir">
                                <table class="table table-sm" style="margin-top: 15px;">
                                    <thead>
                                        <tr>
                                        <th scope="col"><i @click.prevent="mtdmarcartodasmodal()" class="fa fa-plus-square" aria-hidden="true" style="cursor: pointer;font-size: 18px;position: relative;top: 3px;"></i></th>
                                        <th scope="col"><strong>Plano</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(planospagamento, index) in lstplanosatribuir" :key="planospagamento.index">
                                        <tr>
                                        <td @click.prevent="mtdhabilitamodal(index)" style="font-size: 18px;padding-top: 6.5px;">
                                            <i v-if="planospagamento.marcado===1"  class="fa fa-check-square-o" aria-hidden="true" style="cursor: pointer;"></i> 
                                            <i v-else class="fa fa-square-o"  aria-hidden="true" style="cursor: pointer;"></i> 
                                        </td>
                                        <td>{{planospagamento.descricao}}</td>
                                        </tr>                                              
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdaplicaselecao()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadfiliais',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstfiliais              : [],
                pfiltro                 : 1,
                pconteudo               : '',
                pqtdregistros           : 10,
                pqtd_paginas            : 1,
                pagina_atual            : 1,
                pqtd_total_registros    : 0,

                //endereco do servidor
                adrsrvcert              : '',  

                //variáveis do crud
                opcrud                  : 0,
                vcodfil                 : '',
                vdescfil                : '',
                vfantasia               : '',
                vtpjuros                : 0,
                vtpcalcjuros            : 0,
                vtpcalcmulta            : 0,
                vfatjuros               : 0,
                vfatmulta               : 0,
                vidcobrador             : null,
                vobsrecibo              : '',
                vcep                    : '',
                vlogradouro             : '',
				vnumeroendereco         : '',
				vreferencia			    : '',
                vidbairro               : null,
                vidmunicipio            : null,
                viduf                   : null,
                vcnpj                   : '',
                vie                     : '',
                viest                   : '',
                vim                     : '',  
                vfone1                  : '',
                vfone2                  : '',
                vemail                  : '',
                vsite                   : '',
                vdiretorioimagem        : '',
                vdiretoriocertificado   : '',
                vsenhacertificado       : '',
                vcsc                    : '',
                vcscid                  : '',   
                vlogo                   : '',                
                vformulacustoproduto    : '',
                videstoque              : null,
                vidvendedor             : null,
                vidcliente              : null,
                vidplano                : null,
                vidclasse               : null,
                vidclasseservico        : null,
                vgpbotoes               : null,
                vemailautomaticoxml     : '',
                vimprimelogocupom       : 0,  
                vcupomresumido          : 0,  
                vordemitens             : 0,
                vocultardesconto        : 0,   
                vqtdresgatescashback    : 0,
                vqtdcomandas            : 0,
                vtxservico              : 0,
                vtxentrega              : 0,
                vtptaxaservico          : 0,
                vtptaxaentrega          : 0,
                vlayoutimp              : 0,
                ventregaauto            : 0,
                vreservaauto            : 0,
                

                vmensagempedido         : '',
                vnatope                 : '',
                vserie55                : 1,
                vnnf55                  : 1,
                vserie65                : 1,
                vnnf65                  : 1,                
                vcnae                   : '',
                vcrt                    : '1',
                vtpamb                  : 2,
                vidnatop                : null,
                vativarbalanca          : 1,  
                vcreditoindividual      : 0,
                vfatorcreditoutilizar   : 100,
                vativacashback          : 0,  
                vvalidadecashback       : 0,  

                vresgateminimocb        : 0,  
                vsaldocupom             : 0,  
                vbloqueiacbatraso       : 0,  
                vatzclientepdv          : 0,

                lstplanos               : [],
                lstcertificados         : [], 
                vinfofilial             : 1,
                vimppadrao              : 0,
                vreciborodape           : 0,
                vobsetitroca            : '',
                vobsfatped              : '',
                vobsentexterna          : '',
                vobscrediario           : '',
                vgerartagsoftware       : 0,  
                vcalculoicms            : 0,  
                descprodinfocomplemento : 0,

                temformulapadrao        : false,

                vativacashbackliquidez  : 0,

                vfatorliquidez          : 0,
                vtrocovirtual           : 0, 
                vbaixatitcashback       : 0,

                vdiascarencia            : 0,

                // Metas de compra
                lstmetasdecompra        : [], 
                anoslista               : [],
                anoAtual                :  0,
                vmes                    :  1,
                vano                    :  0,
                vvalormeta              :  0,

                // Variável para atribuir planos de pagamento
                vidgrup                 : null,
                lstplanosatribuir       : [],
                lstplanosselec          : [],

                //variável para habilitação dos campos
				ativadesativa           : true,
                
                //rotina dos planos
                vidplanolst             : null,
                vdesconto               : 0,  

                //Variáveis de apis
                
                // Ifood
                swApiIfood              : false,
                vifood                  : false,
                vapisinfo               : 0,
                vclientIdIfood          : '',
                vclientSecretIfood      : '',
                vmerchantIdIfood        : '',

                //Whatsapp
                swApiWhats              : false,
                vApiWhatsapp            : false,
                vidphonenumber          : '',
                vaccesstokenwaba        : '',
                vidwaba                 : '',
                vexpirationtokenwaba    : '',

                //placas
                swApiPlacas             : false,
                vApiPlacas              : false,
                vTokenPlacas            : '',

                //Beira rio
                swApiBeiraRio           : false,
                vApiBeiraRio            : false,
                vClientIdBeiraRio       : '',
                vClientSecretBeiraRio   : '',
                vUsuarioBeiraRio        : '',
                vSenhaBeiraRio          : '',

                /// terceiros autorizados
                vcpfcnpjaut             : '',
                lstcpfcnpjaut           : [],

                //rotina imagens
                arqimgselecionado       : null,

                //pega o path do diretorio padrão das imagens
                pathimgview             : this.$store.state.configpaths.pathimagens,

                //rotina do certificado
                arqcertselecionado      : null,

                //path com o caminho pronto da logo da filial para visualização
                pathimagemvisualizar    : '',

                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },	
                moneyprecision: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 3,
                    masked          : false
                },                			
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FILIAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "codfil",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Razão Social",
                        name: "descfil",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fantasia",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "F padrão",
                        name: "stformula",
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "stformula"
                    },                   
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdverificaclubrill(){
                return false;
            },
            mtdversistemafinanceiro(){
                if(parseInt(this.$store.state.usuario.tpsistema) > 0){
                    if(parseInt(this.$store.state.usuario.tpsistema)===4){//tipo financeiro
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }
            },
            mtddefinirformulapadrao(){
                var vself       = this;
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac',   valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',             valor : 'operarformulapadrao'},
                    {parametro: 'idfilial',       valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idfilialmudar',  valor : vself.vcodfil},
                    {parametro: 'idusuario',      valor : vself.$store.state.usuario.id},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    if($.isNumeric(response.data)){
                        vself.$toastr.s("Registro processado com sucesso", 'Sucesso!');
                        vself.temformulapadrao = parseInt(response.data) === 1 ? true : false; 
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdverificaecommerce(){
                return util.opcaousuario('002Z.001J.005L', this.$store.state.perfilusuario)
            },     
            mtdverificarillpay(){
                return util.opcaousuario('002Z.001J.006L', this.$store.state.perfilusuario)
            },     
            mtdprocessaenviocert(pathcert, vencimentcert, arquivoscert, opcert){
                let vself = this;                 
              
                let path       = pathcert;
                let vencimento = vencimentcert;
                let arquivos   = arquivoscert;
                let op         = opcert; 

                

                let parametros      = [
                    {parametro: 'idclientesac',   valor : vself.$store.state.filialpadrao.idcliente},   
                    {parametro: 'op',             valor : "registracertificadofilial"},
                    {parametro: 'idfilialcert',   valor : vself.vcodfil},
                    {parametro: 'opcert',         valor : op},
                    {parametro: 'vencimento',     valor : vencimento}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    if(op == 1){
                        if ($.isNumeric(response.data)){
                            
                            vself.$toastr.s('Arquivo enviado com sucesso!', 'Informação!');
                            vself.lstcertificados = arquivos;
                    
                        }else{
                            vself.mtdconfirmaexclusaocertificado(path);
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                    }else{
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Arquivo excluido com sucesso!', 'Informação!');
                            vself.lstcertificados = arquivos;
                        
                        }else{
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
             
                }); 
            },  
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},     
            mtdaddcpfcnpjaut(){

                /// verifica se tem forma valida - guga
                const cpfcnpj = this.vcpfcnpjaut.replace(/[^0-9]/g, ''); 
                const isCpf = cpfcnpj.length === 11; 
                const isCnpj = cpfcnpj.length === 14; 

                if (!isCpf && !isCnpj) {
                    this.$toastr.w('CPF ou CNPJ inválido!', 'Informação!');
                    return; 
                }
                /// outras verificações - guga
                if(this.vcnpj === this.vcpfcnpjaut){
                    this.$toastr.w('O CNPJ do autorizado não pode ser o mesmo da filial!', 'Informação!'); 
                }else if(this.lstcpfcnpjaut.length === 10){
                    this.$toastr.w('A quantidade de autorizados não pode ser superior a 10!', 'Informação!'); 
                }
                else if(util.findValInArray(this.lstcpfcnpjaut, 'cpfcnpj', this.vcpfcnpjaut.replace(/[^0-9]/g, ''))){
                    this.$toastr.w('Autorizado já incluso!', 'Informação!'); 
                }else{
                    let docterceiro = {
                       'cpfcnpj' : this.vcpfcnpjaut.replace(/[^0-9]/g, ''),
                    }
                    this.lstcpfcnpjaut.push(docterceiro)
                    this.vcpfcnpjaut = '';
                }
            },  
            mtdexcluircpfcnpjaut(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstcpfcnpjaut, 'cpfcnpj', item.cpfcnpj);
                this.lstcpfcnpjaut.splice(indiceitem, 1);                
            },     
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },
            formatadoc(doc){
                return util.formatacpfcnpj(doc);
            },
            mtdselecionarcertificado(event){
                let vself = this;           
                if (vself.vsenhacertificado   === ''){
                    vself.$toastr.w('Informe, primeiramente, a senha do certificado!', 'Informação!'); 
                    vself.arqcertselecionado    = null;
                    $('#ipselecionarcertificado').val('');
                    $('#edsenhacertificado').focus();
                    return;
                }   
                if (vself.vcnpj === ''){
                    vself.$toastr.w('Informe o CNPJ do emissor!', 'Informação!'); 
                    vself.arqcertselecionado    = null;
                    $('#ipselecionarcertificado').val('');
                    $('#edcnpj').focus();
                    return;
                }                   
                vself.arqcertselecionado = event.target.files[0];
                let extensao = util.extensaoarquivo(vself.arqcertselecionado);
                if (extensao.toUpperCase() !== 'PFX'){
                   vself.$toastr.w('Arquivo de certificado inválido!', 'Informação!'); 
                }else{
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathcertificados + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretoriocertificado;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : vself.arqcertselecionado},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : vself.arqcertselecionado.name},
                        {parametro: 'origem',           valor  : 'certificado'},
                        {parametro: 'senhacertificado', valor  : vself.vsenhacertificado}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            vself.lstcertificados       = response.data.arquivos;
                            vself.arqcertselecionado    = null;
                            $('#ipselecionarcertificado').val('');
                            if (response.data.arquivos[0].nome === ''){
                                vself.$toastr.w('Impossível ler as informações do certificado. Verifique a senha e tente novamente!', 'Informação!');
                                vself.mtdconfirmaexclusaocertificado(response.data.arquivos[0].patharquivo);
                                loader.hide();
                                return;
                            }
                            if (response.data.arquivos[0].cnpjcpf !== null){
                                const cnpjprefixo = vself.vcnpj.replace(/[^\d]+/g, '').substring(0, 8);
                                
                                if (!response.data.arquivos[0].cnpjcpf.startsWith(cnpjprefixo)){
                                    vself.$toastr.w('CNPJ não pertence ao emissor cadastrado!', 'Informação!');
                                    vself.mtdconfirmaexclusaocertificado(response.data.arquivos[0].patharquivo);
                                    loader.hide();
                                    return;
                                }     
                            }  
                            vself.mtdprocessaenviocert(response.data.arquivos[0].patharquivo, response.data.arquivos[0].validade, response.data.arquivos, 1);
                            //vself.$toastr.s('Arquivo enviado com sucesso!', 'Informação!');
                        }else{                       
                            vself.arqcertselecionado = null;
                            $('#ipselecionarcertificado').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');                       
                        vself.arqcertselecionado = null;
                        $('#ipselecionarcertificado').val('');
                    });     
                }
            },
            mtdexcluircertificado(nomearquivo){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma remoção do certificado?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdconfirmaexclusaocertificado(nomearquivo);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },  
            mtdconfirmaexclusaocertificado(nomearquivo){
                let vself        = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathcertificados + 
                                vself.$store.state.filialpadrao.idcliente +'/'+
                                vself.vdiretoriocertificado;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : nomearquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdprocessaenviocert('', '', response.data.arquivos, 2);
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                                                  
            },                 
            mtdselecionarimagemfilial(event){                
                let vself = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgfiliais + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.vlogo                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.pathimagemvisualizar = vself.pathimgview+vself.vlogo;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgfilial').val('');
                    }else{
                        vself.vlogo             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgfilial').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vlogo             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgfilial').val('');
                });                
            },
            mtdexcluirimgfilial(){
                let vself = this;
                if (!util.contemstring(vself.pathimagemvisualizar, 'semimagem')){                    
                    let loader       = vself.$loading.show();
                    let localarquivo = vself.$store.state.configpaths.pathimgfiliais + 
                                    vself.$store.state.filialpadrao.idcliente +'/'+
                                    vself.vdiretorioimagem;

                    let parametros      = [
                        {parametro: 'op',               valor  : "excluirarquivo"},
                        {parametro: 'patharquivo',      valor  : vself.vlogo},
                        {parametro: 'localarquivo',     valor  : localarquivo}
                        
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                            vself.vlogo = '';
                            vself.pathimagemvisualizar = vself.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                        }else{                        
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    });                  
                }
            },            
            mtdselect2_def(){
                let vself = this;
                //selects do crud
                $("#cbcobrador").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcobradores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcobrador = $("#cbcobrador").val();
                });
                $("#cbbairro").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbairros',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidbairro = $("#cbbairro").val();
                });
                $("#cbmunicipio").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmunicipios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmunicipio = $("#cbmunicipio").val();
                });
                $("#cbuf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbufs',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.viduf = $("#cbuf").val();
                });
                $("#cbplanopagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidplanolst = $("#cbplanopagamento").val();
                });
                $("#cbclasse").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbclassesimpostos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidclasse = $("#cbclasse").val();
                });   
                $("#cbclasseservico").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbclassesimpostos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidclasseservico = $("#cbclasseservico").val();
                });                                                
                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
                });
				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				});				
                $("#cbcliente").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcliente = $("#cbcliente").val();
                });
				$("#cbplano").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbplanospagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidplano = $("#cbplano").val();
                });
                $("#cbgpbotoes").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupobotoes',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vgpbotoes = $("#cbgpbotoes").val();
                });
                $("#cbnatop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidnatop = $("#cbnatop").val();
                });
                $("#cbinfcomplementar").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbinformacoescomplementares',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidinformacaocomplementar = $("#cbinfcomplementar").val();
                });  
                $("#cbgruppagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac: vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgruposplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: "bootstrap",
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidgrup = $("#cbgruppagamento").val();
                    $("#cbgruppagamento").on('change', () => {
                    vself.listarplanosatr();
                    });
                });                                                                                
            },          
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and f.codfil='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.fantasia) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregafiliais(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregafiliais(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    vself.lstfiliais = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstfiliais = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vcodfil                   = '';
                this.vdescfil                  = '';
                this.vfantasia                 = '';
                this.vtpjuros                  = 0;
                this.vtpcalcjuros              = 0;
                this.vtpcalcmulta              = 0;
                this.vfatjuros                 = 0;
                this.vfatmulta                 = 0;
                this.vidcobrador               = null;
                this.vcep                      = '';
                this.vlogradouro               = '';
				this.vnumeroendereco           = '';
				this.vreferencia			   = '';
                this.vidbairro                 = null;
                this.vidmunicipio              = null;
                this.viduf                     = null;
                this.vcnpj                     = '';
                this.vie                       = '';
                this.viest                     = '';
                this.vim                       = '';
                this.vfone1                    = '';
                this.vfone2                    = '';
                this.vemail                    = '';
                this.vsite                     = '';
                this.vlogo                     = '';
                this.vdiretorioimagem          = '';
                this.vdiretoriocertificado     = '';
                this.vsenhacertificado         = '';
                this.vcsc                      = '';
                this.vcscid                    = '',
                this.vformulacustoproduto      = 'PC + (PC * IPI) + ((PC + (PC * IPI) )* ICM) + ((PC + (PC * IPI)) * FT) + ((PC + (PC * IPI)) * OT) + (PV * PIS) + (PV * COF) + STB';
                this.videstoque                = null;  
                this.vmensagempedido           = '';
                this.vqtdresgatescashback      = 0;
                this.vnatope                   = '';
                this.vserie55                  = 1;
                this.vnnf55                    = 1;
                this.vserie65                  = 1;
                this.vnnf65                    = 1;                
                this.vcnae                     = '';
                this.vcrt                      = '1';
                this.vtpamb                    = 2;   
                this.vidnatop                  = null;  
                this.vativarbalanca            = 1;  
                this.vcreditoindividual        = 0;
                this.vfatorcreditoutilizar     = 100;
                this.vativacashback            = 0;         
                this.vvalidadecashback         = 0;

                this.vresgateminimocb          = 0;
                this.vsaldocupom               = 0;
                this.vbloqueiacbatraso         = 0;
                this.vatzclientepdv            = 0;

                this.lstplanos                 = [];
                this.lstmetasdecompra          = [];
                this.lstcertificados           = [];
                this.lstcpfcnpjaut             = [];
                this.vcpfcnpjaut               = '';
                this.vmes                      =  1;
                this.anoatual                  =  0
                this.vano                      =  0;
                this.vvalormeta                =  0;

                this.vinfofilial               = 1;
                this.vimppadrao                = 0;
                this.vreciborodape             = 0;
                this.vobsetitroca              = '';
                this.vobsrecibo                = '';
                this.vobsfatped                = '';
                this.vobsentexterna            = '';
                this.vobscrediario             = '';

                this.vidplano                  = null;
                this.vidvendedor               = null;
                this.vidcliente                = null;
                this.vidclasse                 = null;
                this.vidclasseservico          = null; 
                this.vgpbotoes                 = null;
                this.vemailautomaticoxml       = '';
                this.vimprimelogocupom         = 0;
                this.vcupomresumido            = 0;
                this.vdesconto                 = 0;
                this.vordemitens               = 0;
                this.vocultardesconto          = 0;                    
                this.vidinformacaocomplementar = null;
                this.vdefvendedorcliente       = 0;
                this.vgerartagsoftware         = 0;  
                this.vcalculoicms              = 0;  
                this.vdescprodinfocomplemento  = 0; 
                this.vativacashbackliquidez    = 0;
                this.vfatorliquidez            = 0;
                this.vtrocovirtual             = 0;
                this.vbaixatitcashback         = 0; 
                this.vqtdcomandas              = 0;
                this.vtxservico                = 0;
                this.vtxentrega                = 0; 
                this.vtptaxaservico            = 0; 
                this.vtptaxaentrega            = 0;
                this.vlayoutimp                = 0; 
                this.vreservaauto              = 0;
                this.ventregaauto              = 0;
                this.vdiascarencia             = 0;
 
                this.vidgrup                   = null;

                //Luiz Trindade - Formatação das variáveis de cadastro da API do ifood
                this.vclientIdIfood            = '';
                this.vclientSecretIfood        = '';
                this.vmerchantIdIfood          = '';
                this.vidwaba                   = '';
                this.vidphonenumber            = '';
                this.vaccesstokenwaba          = '';
                this.vexpirationtokenwaba      = '';
                
                this.vTokenPlacas              = '';

                this.vClientIdBeiraRio              = '';
                this.vClientSecretBeiraRio          = '';
                this.vUsuarioBeiraRio              = '';
                this.vSenhaBeiraRio                = '';

                if(this.opcrud===1){
                    setTimeout(() => {
                        $('#cbcobrador').val(null).trigger('change');
                        $('#cbnatop').val(null).trigger('change');                
                        $('#cbvendedor').val(null).trigger('change');
                        $('#cbbairro').val(null).trigger('change');
                        $('#cbmunicipio').val(null).trigger('change');
                        $('#cbestoque').val(null).trigger('change');
                        $('#cbplanopagamento').val(null).trigger('change');
                        $('#cbplano').val(null).trigger('change');
                        $('#cbclasse').val(null).trigger('change');
                        $('#cbuf').val(null).trigger('change');                
                        $('#cbcliente').val(null).trigger('change');
                        $('#cbinfcomplementar').val(null).trigger('change'); 
                        $('#cbgruppagamento').val(null).trigger('change');
                        $('#cbgpbotoes').val(null).trigger('change');                   
                    }, 300);
                }
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
				$('#pncadastro').fadeIn(700);
				$('.nav-tabs a[href="#dvendereco"]').tab('show');
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.001J.001L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo   = 'INCLUSÃO DE FILIAIS';
                    this.itensbc.item1.ativo    = true;
                    this.itensbc.item2.ativo    = true;
                    this.ativadesativa          = false;
                    this.mtdpreparacrud(1);
                    this.vdiretorioimagem       = util.GerarStringAleatoria();
                    this.vdiretoriocertificado  = util.GerarStringAleatoria();
                    this.pathimagemvisualizar   = this.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstfiliais = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (vself.lstcertificados.length > 0){
                    if (vself.lstcertificados[0].cnpjcpf !== null){
                        const cnpjprefixo = vself.vcnpj.replace(/[^\d]+/g, '').substring(0, 8);
                        if (!vself.lstcertificados[0].cnpjcpf.startsWith(cnpjprefixo)) {
                            vself.$toastr.w('CNPJ do emissor difere do CNPJ cadastrado no certificado!', 'Informação!');
                            $('#edcnpj').focus();
                            return;
                        }     
                    }           
                }
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if (parseFloat(vself.vfatorcreditoutilizar) < 0){
                    vself.$toastr.w('Fator de utiização de cashbak inválido', 'Atenção!');
                    $('#edfatorcreditoutilizar').focus();
                    return;
                }                
                if (parseFloat(vself.vfatorcreditoutilizar) > 100){
                    vself.$toastr.w('Fator de utiização de cashbak não pode ultrapassar os 100%!', 'Atenção!');
                    $('#edfatorcreditoutilizar').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.codfil='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.001J.002L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FILIAIS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.codfil);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.001J.003L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FILIAIS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.codfil);
                }
            },
            mtdecommerceconfig(item){
                this.$router.push({name: 'ecommerceconfig',  params: {idfilial: item.codfil}});
            },
            mtdrillpayconfig(item){
                this.$router.push({name: 'rillpayconfig',  params: {idfilial: item.codfil}});
            },
            mtdcluberillsoftconfig(item){
                this.$router.push({name: 'clubrillsoftconfig',  params: {idfilial: item.codfil}});
            },
            mtdigualarcampos(registro){
                this.vcodfil                  = registro.codfil;
                this.vdescfil                 = registro.descfil;
                this.vfantasia                = registro.fantasia;
                this.vtpjuros                 = registro.tpjuros;
                this.vtpcalcjuros             = registro.tpcalcjuros;
                this.vtpcalcmulta             = registro.tpcalcmulta;
                this.vfatjuros                = parseFloat(registro.fatjuros);
                this.vfatmulta                = parseFloat(registro.fatmulta);
                this.vidcobrador              = registro.idcobrador;
                this.vcep                     = registro.cep;
                this.vlogradouro              = registro.logradouro;
				this.vnumeroendereco          = registro.numeroendereco;
				this.vreferencia			  = registro.referencia;
                this.vidbairro                = registro.idbairro;
                this.vidmunicipio             = registro.idmunicipio;
                this.viduf                    = registro.iduf;
                this.vcnpj                    = registro.cnpj;
                this.vie                      = registro.ie;
                this.viest                    = registro.iest;
                this.vfone1                   = registro.fone1;
                this.vfone2                   = registro.fone2;
                this.vemail                   = registro.email;
                this.vsite                    = registro.site;
                this.vdiretorioimagem         = registro.diretorioimagem      === '' ? util.GerarStringAleatoria() : registro.diretorioimagem;
                this.vdiretoriocertificado    = registro.diretoriocertificado === '' ? util.GerarStringAleatoria() : registro.diretoriocertificado;
                this.vsenhacertificado        = registro.senhacertificado;
                this.vcsc                     = registro.csc;
                this.vcscid                   = registro.cscid;  
                this.vlogo                    = registro.logo;
                this.vformulacustoproduto     = registro.formulacustoproduto;
                this.videstoque               = registro.idestoque;
                this.vidvendedor              = registro.idvendedor;
                this.vidcliente               = registro.idcliente;
                this.vidplano                 = registro.idplano;
                this.vimprimelogocupom        = registro.imprimelogocupom;  
                this.vcupomresumido           = registro.cupomresumido; 
                this.vordemitens              = registro.ordemitens;
                this.vocultardesconto         = registro.ocultardesconto;    
                this.vidclasse                = registro.idclasse;
                this.vidclasseservico         = registro.idclassetaxa;
                this.vemailautomaticoxml      = registro.emailautomaticoxml;
                this.vmensagempedido          = registro.mensagempedido;
                this.vqtdresgatescashback     = registro.qtdresgatescashback;
                this.vnatope                  = registro.natope;
                this.vserie55                 = registro.serie55;
                this.vnnf55                   = registro.nnf55;
                this.vserie65                 = registro.serie65;
                this.vnnf65                   = registro.nnf65;                
                this.vcnae                    = registro.cnae;
                this.vcrt                     = registro.crt;
                this.vtpamb                   = registro.tpamb;
                this.vidnatop                 = registro.idnatop; 
                this.vativarbalanca           = registro.ativarbalanca;
                this.vcreditoindividual       = registro.creditoindividual;
                this.vfatorcreditoutilizar    = registro.fatorcreditoutilizar;
                this.vativacashback           = registro.ativacashback;
                this.vvalidadecashback        = registro.validadecashback;

                this.vresgateminimocb         = registro.resgateminimocb;
                this.vsaldocupom              = registro.saldocupom;
                this.vbloqueiacbatraso        = registro.bloqueiacbatraso;
                this.vatzclientepdv           = registro.atzclientepdv;

                this.vidinformacaocomplementar= registro.idinformacaocomplementar;
                this.vinfofilial              = registro.infofilialimp;
                this.vimppadrao               = registro.imppadrao;
                this.vreciborodape            = registro.reciborodapeinp;
                this.vobsetitroca             = registro.obsetitroca;
                this.vobsrecibo               = registro.obsrecibo;
                this.vobsfatped               = registro.obsfatped;
                this.vobsentexterna           = registro.obsentexterna;
                this.vobscrediario            = registro.obscrediario;
                this.vdefvendedorcliente      = registro.defvendedorcliente;
                this.vgerartagsoftware        = registro.gerartagsoftware;
                this.vcalculoicms             = registro.calculoicms;
                this.vdescprodinfocomplemento = registro.descprodinfocomplemento;
                this.vativacashbackliquidez   = registro.ativacashbackliquidez;
                this.vfatorliquidez           = registro.fatorliquidez;
                this.vtrocovirtual            = registro.trocovirtual;

                this.vbaixatitcashback        = registro.baixatitcashback;
                this.vdiascarencia            = registro.diascarencia;

                this.vqtdcomandas             = registro.qtdcomandas;
                this.vtxservico               = registro.txservico;
                this.vtxentrega               = registro.txentrega; 
                this.vtptaxaservico           = registro.tptaxaservico; 
                this.vtptaxaentrega           = registro.tptaxaentrega;
                this.vlayoutimp               = registro.layoutimp;
                this.vgpbotoes                = registro.idgpbotoes;
                this.temformulapadrao         = parseInt(registro.formulapadrao) === 0 ? false : true;
                this.ventregaauto             = registro.entregaauto;
                this.vreservaauto             = registro.reservaauto;

                //Atribuição de dados de apis
                //Ifood ------------------------------------------------------------------------------
                this.vclientIdIfood           = registro.clientidifood;
                this.vclientSecretIfood       = registro.clientsecretifood;
                this.vmerchantIdIfood         = registro.merchantidifood;
                if(this.vclientIdIfood || this.vclientSecretIfood || this.vmerchantIdIfood){ //switch
                    this.swApiIfood = true;
                }else{
                    this.swApiIfood = false;
                };
                ///////////////////////////////////////////////////////////////////////////////////////////


                //Whatsapp----------------------------------------------------------------------------------
                this.vidwaba                    = registro.idwaba;
                this.vidphonenumber             = registro.idphonenumberwaba;
                this.vaccesstokenwaba           = registro.accesstokenwaba;
                this.vexpirationtokenwaba       = registro.expirationtokenwaba;
                if(this.vidphonenumber || this.vaccesstokenwaba || this.vidwaba || this.vexpirationtokenwaba){//switch
                    this.swApiWhats = true;
                }else{
                    this.swApiWhats = false;
                };
                /////////////////////////////////////////////////////////////////////////////////////////////

                //Api Placas------------------------------------------------------------------------------
                this.vTokenPlacas              = registro.tokenplacas;
                if(this.vTokenPlacas){//switch
                    this.swApiPlacas = true; 
                }else{
                    this.swApiPlacas = true; 
                }
                //////////////////////////////////////////////////////////////////////////////////////////////

                //Beira Rio------------------------------------------------------------------------------
                this.vClientIdBeiraRio        = registro.clientidiep;
                this.vClientSecretBeiraRio    = registro.clientsecretiep;
                this.vUsuarioBeiraRio         = registro.usuarioiep;
                this.vSenhaBeiraRio           = registro.senhaiep;
                if(this.vClientIdBeiraRio || this.vClientSecretBeiraRio || this.vUsuarioBeiraRio || this.vSenhaBeiraRio){//switch
                    this.swApiBeiraRio = true;
                }else{
                    this.swApiBeiraRio = false;
                };


                this.lstplanos                = registro.planos;  
                this.lstcertificados          = registro.certificados;
                this.lstcpfcnpjaut            = registro.autorizados;                    
                this.lstmetasdecompra         = registro.metas;
                
                this.pathimagemvisualizar     = this.pathimgview+this.vlogo;

                var defcobrador  = new Option(registro.nomecobrador, this.vidcobrador, true, true);
                $('#cbcobrador').append(defcobrador).trigger('change');

                var defbairro  = new Option(registro.descbairro, this.vidbairro, true, true);
                $('#cbbairro').append(defbairro).trigger('change');                

                var defmunicipio  = new Option(registro.descmunicipio, this.vidmunicipio, true, true);
                $('#cbmunicipio').append(defmunicipio).trigger('change');                

                var defuf  = new Option(registro.descuf, this.viduf, true, true);
                $('#cbuf').append(defuf).trigger('change');

                var defestoque  = new Option(registro.descestoque, this.videstoque, true, true);
                $('#cbestoque').append(defestoque).trigger('change');                

                var defvendedor = new Option(registro.nomevendedor, this.vidvendedor, true, true);
                $('#cbvendedor').append(defvendedor).trigger('change');
                
                var defcliente  = new Option(registro.nomecliente, this.vidcliente, true, true);
                $('#cbcliente').append(defcliente).trigger('change');

                var defplano  = new Option(registro.descplano, this.vidplano, true, true);
                $('#cbplano').append(defplano).trigger('change');                

                var defclasse = new Option(registro.descclasse, this.vidclasse, true, true);
                $('#cbclasse').append(defclasse).trigger('change');                

                var defclasseserv = new Option(registro.descclassetaxa, this.vidclasseservico, true, true);
                $('#cbclasseservico').append(defclasseserv).trigger('change'); 

                var defnatop = new Option(registro.descnatop, this.vidnatop, true, true);
                $('#cbnatop').append(defnatop).trigger('change');  
                
                if (parseInt(this.vidinformacaocomplementar) > 0){
                    var definfcomplementar = new Option(registro.descinfcomplementar, this.vidinformacaocomplementar, true, true);
                    $('#cbinfcomplementar').append(definfcomplementar).trigger('change');                
                }else{
                    $('#cbinfcomplementar').val(null).trigger('change');
                }

                if (parseInt(this.vgpbotoes) > 0){
                    var defgpbtns = new Option(registro.descgpbotoes, this.vgpbotoes, true, true);
                    $('#cbgpbotoes').append(defgpbtns).trigger('change');                
                }else{
                    $('#cbgpbotoes').val(null).trigger('change');
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();

                let data = '';
                if(this.vexpirationtokenwaba !== ''){
                    data = this.formatarDataHoraDB(this.vexpirationtokenwaba);
                }

                let registrocrud = {
                    'codfil'                    : this.vcodfil,
					'descfil'                   : this.vdescfil,
					'fantasia'                  : this.vfantasia,
					'tpjuros'                   : this.vtpjuros,
					'tpcalcjuros'               : this.vtpcalcjuros,
					'tpcalcmulta'               : this.vtpcalcmulta,
					'fatjuros'                  : this.vfatjuros,
					'fatmulta'                  : this.vfatmulta,
					'idcobrador'                : this.vidcobrador,
					'cep'                       : this.vcep.replace(/[^0-9]/g, ''),
					'logradouro'                : this.vlogradouro,
					'numeroendereco'            : this.vnumeroendereco,
					'referencia'		        : this.vreferencia,
					'idbairro'                  : this.vidbairro,
					'idmunicipio'               : this.vidmunicipio,
					'iduf'                      : this.viduf,
					'cnpj'                      : this.vcnpj.replace(/[^0-9]/g, ''),
                    'ie'                        : this.vie,
                    'iest'                      : this.viest,
					'fone1'                     : this.vfone1.replace(/[^0-9]/g, ''),
					'fone2'                     : this.vfone2.replace(/[^0-9]/g, ''),
					'email'                     : this.vemail,
                    'site'                      : this.vsite,
                    'diretorioimagem'           : this.vdiretorioimagem,
                    'diretoriocertificado'      : this.vdiretoriocertificado,
                    'senhacertificado'          : this.vsenhacertificado,
                    'csc'                       : this.vcsc,
                    'cscid'                     : this.vcscid, 
					'logo'                      : this.vlogo,
                    'formulacustoproduto'       : this.vformulacustoproduto,
                    'idestoque'                 : this.videstoque,
                    'idvendedor'                : this.vidvendedor,
                    'idcliente'                 : this.vidcliente,
                    'idplano'                   : this.vidplano,
                    'idclasse'                  : this.vidclasse,
                    'idclassetaxa'              : this.vidclasseservico === null ? 0 : this.vidclasseservico,
                    'emailautomaticoxml'        : this.vemailautomaticoxml,
                    'imprimelogocupom'          : this.vimprimelogocupom, 
                    'cupomresumido'             : this.vcupomresumido,
                    'ordemitens'                : this.vordemitens,
                    'ocultardesconto'           : this.vocultardesconto,
                    'mensagempedido'            : this.vmensagempedido,
                    'qtdresgatescashback'       : this.vqtdresgatescashback,
                    'natope'                    : this.vnatope,
                    'serie55'                   : this.vserie55,
                    'nnf55'                     : this.vnnf55,
                    'serie65'                   : this.vserie65,
                    'nnf65'                     : this.vnnf65,                    
                    'cnae'                      : this.vcnae,
                    'crt'                       : this.vcrt,
                    'tpamb'                     : this.vtpamb,
                    'idnatop'                   : this.vidnatop,
                    'ativarbalanca'             : this.vativarbalanca,
                    'creditoindividual'         : this.vcreditoindividual,
                    'fatorcreditoutilizar'      : this.vfatorcreditoutilizar,
                    'ativacashback'             : this.vativacashback, 
                    'ativacashbackliquidez'     : this.vativacashbackliquidez, 
                    'fatorliquidez'             : this.vfatorliquidez, 
                    'trocovirtual'              : this.vtrocovirtual, 
                    'baixatitcashback'          : this.vbaixatitcashback,
                    'qtdcomandas'               : this.vqtdcomandas, 
                    'txservico'                 : this.vtxservico, 
                    'txentrega'                 : this.vtxentrega,
                    'tptaxaservico'             : this.vtptaxaservico,  
                    'tptaxaentrega'             : this.vtptaxaentrega, 
                    'layoutimp'                 : this.vlayoutimp,
                    'infofilialimp'             : this.vinfofilial, 
                    'imppadrao'                 : this.vimppadrao, 

                    'reciborodapeinp'           : this.vreciborodape, 
                    'obsetitroca'               : this.vobsetitroca, 
                    'obsrecibo'                 : this.vobsrecibo, 
                    'obsfatped'                 : this.vobsfatped, 
                    'obsentexterna'             : this.vobsentexterna, 
                    'obscrediario'              : this.vobscrediario,
                    'validadecashback'          : this.vvalidadecashback, 

                    'resgateminimocb'           : this.vresgateminimocb, 
                    'saldocupom'                : this.vsaldocupom, 
                    'bloqueiacbatraso'          : this.vbloqueiacbatraso,  
                    'atzclientepdv'             : this.vatzclientepdv,


                    'idinformacaocomplementar'  : this.vidinformacaocomplementar === null ? 0 : this.vidinformacaocomplementar,
                    'idgpbotoes'                : this.vgpbotoes === null ? 0 : this.vgpbotoes,
                    'defvendedorcliente'        : this.vdefvendedorcliente,
                    'gerartagsoftware'          : this.vgerartagsoftware,
                    'calculoicms'               : this.vcalculoicms,
                    'descprodinfocomplemento'   : this.vdescprodinfocomplemento,
                    'planos'                    : this.lstplanos ,
                    'metas'                     : this.lstmetasdecompra,
                    'autorizados'               : this.lstcpfcnpjaut, 

                    "diascarencia"              : this.vdiascarencia,
                    
                    //Luiz Trindade - Dados de api's para inserção
                    // 'apidata': {
                    //     'ifood': { 
                    //         "clientid"      : this.vclientIdIfood, 
                    //         "clientsecret"  : this.vclientSecretIfood,
                    //         "merchantid"    : this.vmerchantIdIfood
                    //     },
                    // }
                    "clientidifood"                  : this.vclientIdIfood, 
                    "clientsecretifood"              : this.vclientSecretIfood,
                    "merchantidifood"                : this.vmerchantIdIfood,
                    "idwaba"                         : this.vidwaba,
                    "idphonenumberwaba"              : this.vidphonenumber,
                    "accesstokenwaba"                : this.vaccesstokenwaba,
                    "entregaauto"                    : this.ventregaauto,
                    "reservaauto"                    : this.vreservaauto,
                    "expirationtokenwaba"            : data,
                    // 27-10-2025 16:15:40

                    "tokenplacas"                    : this.vTokenPlacas,

                    "clientidbeirario"               : this.vClientIdBeiraRio,
                    "clientsecretbeirario"           : this.vClientSecretBeiraRio,
                    "usuariobeirario"                : this.vUsuarioBeiraRio,
                    "senhabeirario"                  : this.vSenhaBeiraRio,
                };
                
                let parametros      = [
                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgfiliais+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados',    valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                       valor : 'rotinacrud'},
                    {parametro: 'opcrud',                   valor : vself.opcrud},
                    {parametro: 'registro',                 valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',                 valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',                    valor : parseInt(this.opcrud) === 1 ? '002Z.001J.001L' : parseInt(this.opcrud) === 2 ? '002Z.001J.002L' : '002Z.001J.003L'},
                    {parametro: 'idclisac',                 valor : vself.$store.state.filialpadrao.idcliente}
                ];

                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vcodfil;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregafiliais(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdpesquisacep(){
                let vself = this;
                let cepinf = vself.vcep;
                if ( cepinf != ''){
                    if (util.IsCEP(cepinf, '')){
                        let loader = vself.$loading.show();
                        let parametros = [
                            {parametro: 'param1', 		valor: 'consultarcep'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'cep', 			valor: cepinf}
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                var defmun = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                                $('#cbmunicipio').append(defmun).trigger('change');

                                var defbai = new Option(response.data.descbairro, response.data.idbairro, true, true);
                                $('#cbbairro').append(defbai).trigger('change');

                                var defuf = new Option(response.data.descuf, response.data.iduf, true, true);
                                $('#cbuf').append(defuf).trigger('change');

                                vself.vlogradouro     = response.data.logradouro;
                                vself.vreferencia     = response.data.complemento;
                            }else{
                                vself.$toastr.w('CEP inválido ou inexistente!', 'Atenção!');
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    }
                }                
            },
            formatarDataHoraDB(data = '') {
                if (!data) {
                    return '';
                }

                const [dataParte, horaParte] = data.split(' ');

                if (!dataParte || !horaParte) {
                    return '';
                }

                // Detecta separador (pode ser '/' ou '-')
                const separador = dataParte.includes('/') ? '/' : '-';
                const [dia, mes, ano] = dataParte.split(separador);

                // Se algum estiver vazio/undefined, retorna vazio
                if (!dia || !mes || !ano) {
                    return '';
                }

                return `${ano}-${mes}-${dia} ${horaParte}`;
            },
            mtdincplano(){
                if (this.vidplanolst === null) {
                    this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
                    $('#cbplanopagamento').focus();
                }else {
                    let plano = {
                        'idplano'      : this.vidplanolst,
                        'descplano'    : $('#cbplanopagamento').select2('data')[0]['text'],
                        'desconto'     : this.vdesconto
                    };
                    if (!util.findValInArray(this.lstplanos, 'idplano', plano.idplano)) {
                        this.lstplanos.push(plano);
                        this.vidplanolst     = null;
                        this.vdesconto       = 0;
                        $('#cbplanopagamento').val(null).trigger('change');
                        $('#cbplanopagamento').focus();
                    } else {
                        this.$toastr.w('Plano de pagamento já cadastrado!', 'Atenção!');
                        $('#cbplanopagamento').focus();
                    }
                }                
            },
            mtddeletaplano(index) {
                this.lstplanos.splice(index, 1);
            },
            mtdincmeta(){
                if(this.vmes === '') {
                    this.$toastr.w('O mês deve ser informado!', 'Atenção!');
                    $('#edmeta').focus();
                    return;
                }
                if(this.vano === 0) {
                    this.$toastr.w('O ano deve ser informado!', 'Atenção');
                    $('#edano').focus();
                    return;
                } 
                if(parseFloat(this.vvalormeta) === 0) {
                    this.$toastr.w('O valor deve ser informado!', 'Atenção');
                    $('#edvalormeta').focus();
                    return;
                }
                let meta = {
                    'mes'       : parseInt(this.vmes),
                    'ano'       : parseInt(this.vano),
                    'valor'     : this.vvalormeta
                };
                let mesJaCadastrado = false;
                for (let i = 0; i < this.lstmetasdecompra.length; i++) {
                    if (this.lstmetasdecompra[i].mes == meta.mes && this.lstmetasdecompra[i].ano == meta.ano) {
                        mesJaCadastrado = true;
                        break;
                    }
                }
                if (!mesJaCadastrado === true) {
                    this.lstmetasdecompra.push(meta);
                    this.lstmetasdecompra.sort((a, b) => {
                        if (a.ano !== b.ano) {
                            return a.ano - b.ano;
                        } else {
                            return a.mes - b.mes;
                        }
                    });
                    if (this.vmes === 12) {
                        this.vmes = 1;
                    } else {
                        this.vmes++;
                    }
                    
                    //this.vano = 0;
                    this.vvalormeta = 0;
                    $('#edmes').focus();
                } else {
                    this.$toastr.w('Mês já cadastrado no ano selecionado!', 'Atenção!');
                    $('#edmes').focus();
                }
            },
            mtddeletameta(index) {
                this.lstmetasdecompra.splice(index, 1);
            },
            mtdformatavalordecimal(valor, digitos) {
                return util.formatavalordecimais(valor, digitos);
            },

            // Rotinas para atribuição do plano de pagamento
            mtdrotinaplano(){
                $('#cbgruppagamento').val(null).trigger('change'); 
                $('#mdatribuirplano').modal('show');      
                this.listarplanosatr();                             
            },
            listarplanosatr(){
                var vself       = this;
             // let loader      = this.$loading.show();
                let filtro      = this.vidgrup === null ? '' : ' where idpdp='+this.vidgrup;

                console.log(filtro)

                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listarplanos'},
                    {parametro: 'filtro',       valor  : filtro},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    vself.lstplanosatribuir = response.data;
                 // loader.hide();
                }).catch(function (response) {
                    vself.lstplanosatribuir = [];
                 // loader.hide();
                });
            },
            mtdhabilita(index){
                util.habilita(this.lstplanos, 'marcado', index);
            },
            mtdmarcartodas(dados){
                util.marcartodas(this.lstplanos, 'marcado');
            },
            mtdhabilitamodal(index){
                util.habilita(this.lstplanosatribuir, 'marcado', index);
            },
            mtdmarcartodasmodal(){
                util.marcartodas(this.lstplanosatribuir, 'marcado');
            },
            mtdaplicaselecao(valoratribuir){
                let dados  = this.lstplanosatribuir;
                
                for (let i = 0; i < dados.length; i++) {
                    if(dados[i].marcado == 1 ){

                        let lstdados = {
                            'idplano'    : dados[i].id,
                            'descplano'  : dados[i].descricao,
                            'desconto'   : 0,
                            'marcado'    : 0
                        }


                        if (util.findValInArray(this.lstplanos, 'idplano', lstdados.idplano)) {
                                continue;
                        }else{

                            this.lstplanos.push(lstdados);

                            console.log(this.lstplanos);

                        }

                    }
                };
              
                $('#mdatribuirplano').modal('hide');
                                
            },
            mtdexcluirselecionados(){
                let pedidostmp = JSON.parse(JSON.stringify(this.lstplanos));

                this.lstplanos = []

                for (let i = pedidostmp.length - 1; i >= 0; i--) {
                    if (pedidostmp[i].marcado == 1) {

                        let indice = util.getArrayIndexForKey(pedidostmp, 'idplano', pedidostmp[i].idplano);
                       
                        console.log(indice)
                        
                        pedidostmp.splice(indice, 1)

                    }
                    
                }

                this.lstplanos = JSON.parse(JSON.stringify(pedidostmp));

            },
            mtdexcluirselecao(){
                let pedidostmp = JSON.parse(JSON.stringify(this.lstplanos));

                this.lstplanos = []

                for (let i = 0; i < pedidostmp.length; i++) {
                    if (pedidostmp[i].marcado == 0) {
                        
                        let selecionados = {
                            "idplano"   : pedidostmp[i].idplano,
                            "descplano" : pedidostmp[i].descplano,
                            "desconto"  : pedidostmp[i].desconto,
                            "marcado"   : pedidostmp[i].marcado
                        }

                        this.lstplanos.push(selecionados)
                    }
                }
            },
            //APIs
            mtdconfirmadesabilitarifood(){
                let vself = this;
                vself.swApiIfood && vself.vifood
            },
            mtdconfirmadesabilitarApiWhats(){
                let vself = this;
                vself.swApiWhats && vself.vApiWhatsapp
            },
            mtdconfirmadesabilitarApiPlacas(){
                let vself = this;
                vself.swApiPlacas && vself.vApiPlacas
            },
            mtdconfirmadesabilitarApiBeiraRio(){
                let vself = this;
                vself.swApiBeiraRio && vself.vApiBeiraRio
            },

            // ativa e desativa desabilitado temporariamente
            // if(){ $.confirm({
            //             title: 'Confirmação!',
            //             content: 'Deseja desabilitar o método de pagamento CARTÃO DE CRÉDITO?',
            //             icon: 'fa fa-question-circle',
            //             escapeKey: true,
            //             backgroundDismiss: false,
            //             escapeKey: 'nao',
            //             type: 'red',
            //             typeAnimated: true,                        
            //             buttons: {
            //                 sim: {
            //                     text : '<u>S</u>im',
            //                     keys: ['s', 'S'],
            //                     btnClass: 'btn-red',
            //                     action: function () {


            //                     },
            //                 },
            //                 nao: {
            //                     text: '<u>N</u>ão',
            //                     keys: ['n', 'N'],
            //                     action: function () {
                                    
            //                     }
            //                 }
            //             }
            //         });
            //     }
            // },
            //SDK whatsapp botão
            // HandleMessageEvent(event){
            //     if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;

            //     try {
            //         const data = JSON.parse(event.data);
            //         if (data.type === 'WA_EMBEDDED_SIGNUP') {
            //             console.log('message event: ', data); // remove after testing
            //             // your code goes here
            //         }
            //     } catch {
            //         console.log('message event: ', event.data); // remove after testing
            //         // your code goes here
            //     }
            // },
            fbLoginCallback(response) {
                // Callback para login do Facebook
                console.log('fblogincallback');
                if (response.authResponse) {
                    let loader      = this.$loading.show();
                    let dadosWaba = response.authResponse
                    let dados = {
                        codigo : dadosWaba.code,
                    }

                    let vself = this; 
                    let parametros = [
                        { parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        { parametro: 'op', valor: 'vinculawabameta' }, 
                        { parametro: 'dados', valor: JSON.stringify(dados) },         
                    ];
                    // Envio dos parâmetros via POST usando util.reqaxios
                    let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadfiliais.php');
                    retorno.then(function (response) {
                        if (parseInt(response.data.inf) === 1){
                            vself.vaccesstokenwaba = response.data.token
                            vself.vexpirationtokenwaba = response.data.expira
                        }
                        loader.hide();
                    }).catch(function (error) { 
                        console.log('Erro ao vincular conta WABA:' + error)
                        loader.hide();
                    });
                }
            },
            iniciarWhatsAppSignup() {
                try {
                    FB.login(this.fbLoginCallback, {
                        config_id: '472918455610540', 
                        response_type: 'code',
                        override_default_response_type: true,
                        extras: {
                            setup: {},
                            featureType: '',
                            sessionInfoVersion: '3',
                        },
                    });
                } catch (error) {
                    console.error('Error starting WhatsApp Signup:', error);
                }
            },
            cadastrarWebhookWaba(){
                let vself = this; 
                let loader = vself.$loading.show();
                let dados = {
                    idwaba          : vself.vidwaba,
                    idphonenumber   : vself.vidphonenumber,
                    accesstoken     : vself.vaccesstokenwaba,
                    expirationtoken : vself.vexpirationtokenwaba
                }

                let parametros = [
                    { parametro: 'idclientesac',    valor  : vself.$store.state.filialpadrao.idcliente},
                    { parametro: 'op',              valor: 'cadastrawebhookwaba' }, 
                    { parametro: 'dados',           valor: JSON.stringify(dados) },         
                ];
                // Envio dos parâmetros via POST usando util.reqaxios
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    if (parseInt(response.data.inf) === 1){
                        vself.$toastr.s('Webhook cadastrado com sucesso!', 'Informação!');
                    } else {
                        vself.$toastr.e('Erro ao cadastrar webhook: ' + response.data.erro, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (error) { 
                    console.log('Erro ao cadastrar webhook:' + error)
                    loader.hide();
                });
            },
            cadastrarTelefoneWaba(){
                let vself = this; 
                let loader = vself.$loading.show();
                let dados = {
                    idwaba          : vself.vidwaba,
                    idphonenumber   : vself.vidphonenumber,
                    accesstoken     : vself.vaccesstokenwaba,
                    expirationtoken : vself.vexpirationtokenwaba
                }

                let parametros = [
                    { parametro: 'idclientesac',    valor  : vself.$store.state.filialpadrao.idcliente},
                    { parametro: 'op',              valor: 'cadastrartelefonewaba' }, 
                    { parametro: 'dados',           valor: JSON.stringify(dados) },         
                ];
                // Envio dos parâmetros via POST usando util.reqaxios
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    if (parseInt(response.data.inf) === 1){
                        vself.$toastr.s('Telefone cadastrado com sucesso!', 'Informação!');
                    } else {
                        vself.$toastr.e('Erro ao cadastrar telefone: ' + response.data.erro, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (error) { 
                    console.log('Erro ao cadastrar telefone:' + error)
                    loader.hide();
                });
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001J', vself.$store.state.perfilusuario)) {
                        vself.pathimgview  = vself.$store.state.configpaths.pathimagens;
                        vself.adrsrvcert   = 'https://www.'+vself.$store.state.usuario.adrsrv;
						$('#pnlista').fadeIn(700);
						vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();

                        window.addEventListener('message', (event) => {
                        if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;
                        
                        try {
                            const data = JSON.parse(event.data);
                            if (data.type === 'WA_EMBEDDED_SIGNUP') {
                                vself.vidwaba = data.data.waba_id;
                                vself.vidphonenumber = data.data.phone_number_id;
                            }
                        } catch {
                            
                        }
                        });
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

                let dataAtual  = new Date();
                this.anoAtual  = dataAtual.getFullYear();
    
                this.vano      = parseInt(this.anoAtual);
 
                for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
                    if(index===0){
                        this.anoslista[index] = parseInt(this.anoAtual)
                    }else{
                        this.anoslista[index] = this.anoslista[index - 1] + 1;
                    }
                }
                
            }
        },
        computed:{
            //Luiz Trindade - Alteração na lógica de validação, para suportar dados de API's
            validou() {
                return this.vdescfil         === ''   || 
                           this.vfantasia        === ''   || 
                           this.vfone1           === ''   ||
                           this.vlogradouro      === ''   || 
                           this.vnumeroendereco  === ''   || 
                           this.vidbairro        === null || 
                           this.vidmunicipio     === null || 
                           this.viduf            === null || 
                           this.vidcobrador      === null || 
                           this.lstplanos.length === 0    || 
                           this.videstoque       === null || 
                           this.vidvendedor      === null || 
                           this.vidcliente       === null || 
                           this.vidplano         === null || 
                           this.vidclasse        === null || 
                           this.vidnatop         === null ||
                           this.vcep             === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregafiliais(val);
            },
            swApiIfood: function(){
                if(this.swApiIfood){
                    $('#dadosApiIfood').collapse('show')
                } else {
                    $('#dadosApiIfood').collapse('hide')
                }
            },
            swApiWhats: function(){
                if(this.swApiWhats){
                    $('#dadosApiWhats').collapse('show')
                } else {
                    $('#dadosApiWhats').collapse('hide')
                }
            },
            swApiPlacas: function(){
                if(this.swApiPlacas){
                    $('#dadosApiPlacas').collapse('show')
                } else {
                    $('#dadosApiPlacas').collapse('hide')
                }
            },
            swApiBeiraRio: function(){
                if(this.swApiBeiraRio){
                    $('#dadosApiBeiraRio').collapse('show')
                } else {
                    $('#dadosApiBeiraRio').collapse('hide')
                }
            }

        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .img-filial{
        cursor: pointer;
        width: 150px !important;
        height: 155px !important;
    }
    .btn-del-imgfilial{
        position: absolute;
        top: 10px;
        left: 10px;
    }    
    #op_exc_cert{
        cursor: pointer;
        color: #fa5c7c;
    }
    #op_exc_cert:hover{
        filter: brightness(90%)!important;
    }
    .btn-baixar-certificado{
        float: right;
        font-size: 12px!important;
        width: 25px!important;
        height: 25px!important;
        padding: 4px 0px 0px 0px !important;        
    }
    .tptaxassel{
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #4d787c !important;
        color: white !important;
    }
</style>
